import React, { useState, useEffect, useRef, useMemo } from "react";

import api from "../../services/api";
import validadorCpfCnpj from "../../services/validadorCpfCnpj";
import buscaCep from "../../services/buscaCep";
import identifyErrorMenssage from "../../services/identifyErrorMenssage";

import { store } from "react-notifications-component";

import LogoAgroReceita from "../../assets/logo-agroreceita-black.svg";
import CardRadio from "../../components/cardRadio";
import AcordionCard from "../../components/acordionCard";
import InputV3 from "../../components/input/novo/input_v3";
import ModalTermos from '../../components/modal/modalTermos';
import ModalPoliticas from '../../components/modal/modalPoliticas';
import AcordionCardSimulation from "../../components/acordionCard/acordionCardSimulation";


import * as S from "./compraStyles";
import { theme } from "../../styles/theme";
import {
  Auxiliar,
  BodyG,
  BodyP,
  H6,
  Minimo,
  TaglineM,
} from "../../styles/stylesTypography";

export const USER = "@userinfo";

// Checkout de empresas vinculadas a parceiros da API comercial (PLANO API)
const PLANO_API_ID = 10;

const STORAGE_EMPRESA = "parceiros_dados_empresa";

// Parceiro vem na URL: /checkout/parceiros?mm (ou ?parceiro=mm), demais parâmetros (utm) seguem normalmente
const getSlugParceiroUrl = () => {
  const params = new URLSearchParams(window.location.search);

  if (params.get("parceiro")) {
    return params.get("parceiro").trim().toLowerCase();
  }

  for (const [key, value] of params.entries()) {
    if (value === "" && key.trim()) {
      return key.trim().toLowerCase();
    }
  }

  return "";
};
const STORAGE_FATURAMENTO = "parceiros_dados_faturamento";

const CompraParceiros = ({ ...props }) => {
  useEffect(() => {
    const updateReload = localStorage.getItem("@UpdateReload");

    if (updateReload === "true") {
      localStorage.setItem("@UpdateReload", "false");
      window.location.reload();
    }
  }, []);

  // Params
  const [urlParams, setUrlParams] = useState({
    utm_campaign: "",
    utm_source: "",
    utm_medium: "",
    utm_id: "",
    button: "",
  });

  useEffect(() => {
    if (typeof window !== 'undefined') {
      const queryString = window.location.search;
      const params = new URLSearchParams(queryString);
      const allowedParams = ['utm_campaign', 'utm_source', 'utm_medium', 'utm_id', 'button'];
      
      const filteredParams = {};
      allowedParams.forEach(param => {
        filteredParams[param] = params.get(param) || "";
      });
      
      setUrlParams(filteredParams);
    }
  }, []);

  //Acordions
  const [openedAccordion, setOpenedAccordion] = useState(null);
  const [openAccordionKey, setOpenAccordionKey] = useState(null);

  const [activeAccordionEmpresa, setActiveAccordionEmpresa] = useState(true);
  const [activeAccordionFaturamento, setActiveAccordionFaturamento] = useState(true);
  const [activeAccordionPagamento, setActiveAccordionPagamento] = useState(true);

  //Notifications
  const notificationShown = useRef(false);
  const cpfCnpjEmpresaCheckRef = useRef(0);
  const cpfOrCnpjPagamentoCheckRef = useRef(0);

  //Validação
  const [startValidationEmpresa, setStartValidationEmpresa] = useState(false);
  const [startValidationFaturamento, setStartValidationFaturamento] = useState(false);
  const [startValidationPagamento, setStartValidationPagamento] = useState(false);

  //Acordion 1
  const [selectedPlan, setSelectedPlan] = useState(null);
  const [idPlanCard, setIdPlanCard] = useState(0);
  const [idPlanGridCard, setIdPlanGridCard] = useState(0);
  const [userCount, setUserCount] = useState(0);
  const [cupom, setCupom] = useState("");
  const [revenues, setRevenues] = useState(0);

  const [qtdDocuments, setQtdDocuments] = useState("");
  const [qtdPrescriptions, setQtdPrescriptions] = useState("");

  const [valuePerMonth, setValuePerMonth] = useState("");
  const [resultvalueUserMonth, setResultValueUserMonth] = useState("");
  const [valueRevenuesPrePago, setValueRevenuesPrePago] = useState("");
  const [valueRevenuesPrePagoWithNotDiscount, setValueRevenuesPrePagoWithNotDiscount] = useState("");
  const [resultValuePrepago, setResultValuePrepago] = useState("");
  const [resultValueMonth, setResultValueMonth] = useState("");

  const [discountMonths, setDiscountMonths] = useState(0);
  const [messageCupom, setMessageCupom] = useState("");
  const [valueMonthNotDiscount, setValueMonthNotDiscount] = useState("");
  const [valueMonthWithDiscount, setValueMonthWithDiscount] = useState("");
  const [valueMonth, setValueMonth] = useState("");
  const [valueAnual, setValueAnual] = useState("");
  const [fullValueAnual, setFullValueAnual] = useState("");
  const [valueDiscount, setValueDiscount] = useState("");
  const [fullValueTotalWithDiscount, setFullValueTotalWithDiscount] = useState("");

  const [valueAnualCalcWithMonth, setValueAnualCalcWithMonth] = useState("");

  const [resultValueTotalWithDiscount, setResultValuetotalWithDiscount] =
    useState("");

  const [valueMonthDiscount, setValueMonthDiscount] = useState("");
  const [valueTotalWithDiscount, setValueTotalWithDiscount] = useState("");
  const [fullValueForUsers, setFullValueForUsers] = useState("");

  const [acordionPlanError, setAcordionPlanError] = useState(false);
  const [errorsPlan, setErrorsPlan] = useState({
    selectedPlan: false,
    userCount: false,
    revenues: false,
  });

  //Parceiro
  const [parceiro, setParceiro] = useState({ value: "", label: "" });
  const [errorParceiro, setErrorParceiro] = useState(false);

  const [cargos, setCargos] = useState([]);
  const [workSpaceOptions, setWorkSpaceOptions] = useState([]);

  //Acordion 3
  const [cpfCnpjEmpresa, setCpfOrCnpjEmpresa] = useState("");
  const [getCpfCnpjEmpresa, setGetCpfOrCnpjEmpresa] = useState("");

  const [showOtherFields, setShowOtherFields] = useState(false);

  const [nomeCompletoEmpresa, setNomeCompletoEmpresa] = useState("");
  const [rgEmpresa, setRgEmpresa] = useState("");

  const [razaoSocialEmpresa, setRazaoSocialEmpresa] = useState("");
  const [telefoneEmpresa, setTelefoneEmpresa] = useState("");
  const [nomeFantasiaEmpresa, setNomeFantasiaEmpresa] = useState("");
  const [cepEmpresa, setCepEmpresa] = useState("");
  const [enderecoEmpresa, setEnderecoEmpresa] = useState("");
  const [numeroEmpresa, setNumeroEmpresa] = useState("");
  const [complementoEmpresa, setComplementoEmpresa] = useState("");
  const [bairroEmpresa, setBairroEmpresa] = useState("");
  const [cidadeEmpresa, setCidadeEmpresa] = useState("");
  const [ufEmpresa, setUfEmpresa] = useState({ value: "", label: "" });
  const [inscricaoEstadualEmpresa, setInscricaoEstadualEmpresa] = useState("");
  const [categoriaEmpresa, setCategoriaEmpresa] = useState({
    value: "",
    label: "",
  });
  const [categoriaOptions, setCategoriaOptions] = useState([]);

  const [acordionEmpresaError, setAcordionEmpresaError] = useState(false);
  const [errorsEmpresa, setErrorsEmpresa] = useState({
    cpfCnpjEmpresa: false,
    nomeCompletoEmpresa: false,
    rgEmpresa: false,
    razaoSocialEmpresa: false,
    telefoneEmpresa: false,
    nomeFantasiaEmpresa: false,
    cepEmpresa: false,
    enderecoEmpresa: false,
    numeroEmpresa: false,
    complementoEmpresa: false,
    bairroEmpresa: false,
    cidadeEmpresa: false,
    ufEmpresa: false,
    inscricaoEstadualEmpresa: false,
    categoriaEmpresa: false,
  });

  //Acordion 4
  const [nameUserFaturamento, setNameUserFaturamento] = useState("");
  const [emailUserFaturamento, setEmailUserFaturamento] = useState("");
  const [phoneUserFaturamento, setPhoneUserFaturamento] = useState("");

  const [cargoUserFaturamento, setCargoUserFaturamento] = useState({
    value: 0,
    label: ''
  });

  const [workSpaceFaturamento, setWorkSpaceFaturamento] =
    useState({
      value: "",
      label: "",
    });
  const [numeroPedidoFaturamento, setNumeroPedidoFaturamento] = useState("");

  const [acordionFaturamentoError, setAcordionFaturamentoError] = useState(false);
  const [errorsFaturamento, setErrorsFaturamento] = useState({
    nameUserFaturamento: false,
    emailUserFaturamento: false,
    phoneUserFaturamento: false,
    cargoUserFaturamento: false,
    workSpaceFaturamento: false,
  });

  //Acordion 5
  const [selectedMetod, setSelectedMetod] = useState("cartao_credito");
  const [parcelasOptions, setParcelasOptions] = useState([]);
  const [selectedParcelas, setSelectedParcelas] = useState({
    value: "",
    label: "",
    valor_parcela: "",
    total_juros: "",
  });

  const [cpfOrCnpjPagamento, setCpfOrCnpjPagamento] = useState("");
  const [emailPagamento, setEmailPagamento] = useState("");
  const [phonePagamento, setPhonePagamento] = useState("");
  const [cepPagamento, setCepPagamento] = useState("");
  const [enderecoPagamento, setEnderecoPagamento] = useState("");
  const [numeroPagamento, setNumeroPagamento] = useState("");
  const [complementoPagamento, setComplementoPagamento] = useState("");
  const [bairroPagamento, setBairroPagamento] = useState("");
  const [cidadePagamento, setCidadePagamento] = useState("");

  const [ufPagamento, setUFPagamento] = useState({
    value: "",
    label: "",
  });

  const ufOptions = [
    { value: "AC", label: "Acre" },
    { value: "AL", label: "Alagoas" },
    { value: "AP", label: "Amapá" },
    { value: "AM", label: "Amazonas" },
    { value: "BA", label: "Bahia" },
    { value: "CE", label: "Ceará" },
    { value: "DF", label: "Distrito Federal" },
    { value: "ES", label: "Espírito Santo" },
    { value: "GO", label: "Goiás" },
    { value: "MA", label: "Maranhão" },
    { value: "MT", label: "Mato Grosso" },
    { value: "MS", label: "Mato Grosso do Sul" },
    { value: "MG", label: "Minas Gerais" },
    { value: "PA", label: "Pará" },
    { value: "PB", label: "Paraíba" },
    { value: "PR", label: "Paraná" },
    { value: "PE", label: "Pernambuco" },
    { value: "PI", label: "Piauí" },
    { value: "RJ", label: "Rio de Janeiro" },
    { value: "RN", label: "Rio Grande do Norte" },
    { value: "RS", label: "Rio Grande do Sul" },
    { value: "RO", label: "Rondônia" },
    { value: "RR", label: "Roraima" },
    { value: "SC", label: "Santa Catarina" },
    { value: "SP", label: "São Paulo" },
    { value: "SE", label: "Sergipe" },
    { value: "TO", label: "Tocantins" },
  ];

  //cartão de crédito do titular
  const [nomeTitularCartao, setNomeTitularCartao] = useState("");
  const [numeroCartao, setNumeroCartao] = useState("");
  const [validade, setValidade] = useState("");
  const [cvv, setCvv] = useState("");

  const [acordionPagamentoError, setAcordionPagamentoError] = useState(false);
  const [errorsPagamento, setErrorsPagamento] = useState({
    parcelas: false,
    cpfOrCnpjPagamento: false,
    emailPagamento: false,
    phonePagamento: false,
    cepPagamento: false,
    enderecoPagamento: false,
    numeroPagamento: false,
    complementoPagamento: false,
    bairroPagamento: false,
    cidadePagamento: false,
    ufPagamento: false,

    nomeTitularCartao: false,
    numeroCartao: false,
    validade: false,
    cvv: false,
  });

  const [isConfirmLoading, setIsConfirmLoading] = useState(false);
  const [termosAceitos, setTermosAceitos] = useState(false);
  const [acordoAceito, setAcordoAceito] = useState(false);

  const [showTermos, setShowTermos] = useState(false);
  const [showPolitica, setShowPolitica] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      const headerElement = document.getElementById('header');
      if (headerElement) {
        headerElement.scrollIntoView({
          behavior: 'smooth'
        });
      }
    }, 1000); 

    return () => clearTimeout(timer);
  }, []);

  // const tagRdStation = async () => {
  //   try {
  //     await api.get(`/compra/tag-carrinho`);
  //   } catch {}
  // };

  // useEffect(() => {
  //   return () => {
  //     tagRdStation();
  //   };
  // }, []);

  const saveGtmDataCompra = () => {
    localStorage.setItem('gtm_data_compra_checkout', JSON.stringify({
      nome: nameUserFaturamento,
      email: emailUserFaturamento,
      telefone: phoneUserFaturamento,
    }));
  };

  const getWorkspaces = async () => {
    try {
      const workspacesResponse = await api.get(`/workspaces`);
      const workspaces = workspacesResponse.data.data;
      setWorkSpaceOptions(workspaces);
    } catch {}
  }

  const getCategoria = async () => {
    const response = await api.get("/info/categorias");

    const formattedCategoria = response.data.data.map((depto) => ({
      value: depto.id,
      label: depto.nome,
    }));

    setCategoriaOptions(formattedCategoria);
  };

  const getJobsCategories = async () => {
      try {
          const response = await api.get('/jobs/categories');

          if (response.data.data) {
              setCargos(response.data.data);
          }
      } catch (error) {}
  };

  const getParceiro = async () => {
    const slug = getSlugParceiroUrl();

    try {
      if (!slug) {
        throw new Error("Link de compra inválido - Solicite ao parceiro o link correto.");
      }

      const response = await api.get(`/compra/parceiros/${encodeURIComponent(slug)}`);

      setParceiro({
        value: slug,
        label: response.data.data.nome_fantasia,
      });
    } catch (error) {
      setErrorParceiro(true);

      store.addNotification({
        title: "Erro!",
        message: identifyErrorMenssage(error, error?.message || "Parceiro não encontrado - Verifique o link de compra recebido do parceiro."),
        type: "danger",
        insert: "top",
        container: "top-right",
        animationIn: ["animated", "fadeIn"],
        animationOut: ["animated", "fadeOut"],
        dismiss: {
          duration: 4000,
          onScreen: true,
        },
      });
    }
  };

  useEffect(() => {
    getWorkspaces();
    getCategoria();
    getJobsCategories();
    getParceiro();
  }, []);

  useEffect(() => {
    if (userCount > 0) {
      const cleanedValue = valueMonthNotDiscount.replace(/\./g, "").replace(",", ".");
      
      const numericValue = parseFloat(cleanedValue);

      const valuePerMonthWithUser = userCount * numericValue;

      const formattedValue = valuePerMonthWithUser.toLocaleString("pt-BR", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });

      setResultValueUserMonth(formattedValue);
    } else {
      setResultValueUserMonth("0,00");
    }
  }, [userCount, valuePerMonth]);

  const formatCPF = (value) => {
    if (!value) return "";

    value = value.replace(/\D/g, "");

    value = value.replace(/(\d{3})(\d)/, "$1.$2");
    value = value.replace(/(\d{3})(\d)/, "$1.$2");
    value = value.replace(/(\d{3})(\d{1,2})$/, "$1-$2");

    return value;
  };

  const validateCPF = (cpf) => {
    cpf = cpf.replace(/\D/g, "");

    if (cpf.length !== 11 || /^(\d)\1{10}$/.test(cpf)) {
      return false;
    }

    let sum = 0;
    for (let i = 0; i < 9; i++) {
      sum += parseInt(cpf.charAt(i)) * (10 - i);
    }
    let remainder = (sum * 10) % 11;
    if (remainder === 10) remainder = 0;
    if (remainder !== parseInt(cpf.charAt(9))) {
      return false;
    }

    sum = 0;
    for (let i = 0; i < 10; i++) {
      sum += parseInt(cpf.charAt(i)) * (11 - i);
    }
    remainder = (sum * 10) % 11;
    if (remainder === 10) remainder = 0;
    if (remainder !== parseInt(cpf.charAt(10))) {
      return false;
    }

    return true;
  };

  const formatRGRealtime = (value) => {
    let clean = value.toUpperCase().replace(/[^0-9A-Z]/g, "");

    clean = clean.slice(0, 10);

    const digits = clean.slice(0, 9);
    const lastChar = clean.slice(8);

    let formatted = digits;

    if (formatted.length >= 3) {
      formatted = `${formatted.slice(0, 2)}.${formatted.slice(2)}`;
    }
    if (formatted.length >= 7) {
      formatted = `${formatted.slice(0, 6)}.${formatted.slice(6)}`;
    }
    if (formatted.length >= 10) {
      formatted = `${formatted.slice(0, 10)}-${lastChar}`;
    } else if (lastChar) {
      formatted += `-${lastChar}`;
    }

    return formatted;
  };

  const validateRG = (rg) => {
    const rgLimpo = rg.replace(/[.,-\/]/g, "");
    
    const isValid = rgLimpo.length >= 6 && rgLimpo.length <= 9;
    
    return isValid;
  };

  const validatePhone = (phone) => {
    const onlyNumbers = phone.replace(/\D/g, "");

    return onlyNumbers.length === 10 || onlyNumbers.length === 11;
  };

  const formatCNPJ = (value) => {
    if (!value) return "";
    value = value.replace(/\D/g, "").slice(0, 14);
    value = value.replace(/^(\d{2})(\d)/, "$1.$2");
    value = value.replace(/^(\d{2})\.(\d{3})(\d)/, "$1.$2.$3");
    value = value.replace(/\.(\d{3})(\d)/, ".$1/$2");
    value = value.replace(/(\d{4})(\d)/, "$1-$2");
    return value;
  };

  const validateCNPJ = (cnpj) => {
    cnpj = cnpj.replace(/\D/g, "");
    if (cnpj.length !== 14 || /^(\d)\1{13}$/.test(cnpj)) return false;

    let length = cnpj.length - 2;
    let numbers = cnpj.substring(0, length);
    const digits = cnpj.substring(length);
    let sum = 0;
    let pos = length - 7;

    for (let i = length; i >= 1; i--) {
      sum += numbers.charAt(length - i) * pos--;
      if (pos < 2) pos = 9;
    }

    let result = sum % 11 < 2 ? 0 : 11 - (sum % 11);
    if (result !== parseInt(digits.charAt(0))) return false;

    length = length + 1;
    numbers = cnpj.substring(0, length);
    sum = 0;
    pos = length - 7;

    for (let i = length; i >= 1; i--) {
      sum += numbers.charAt(length - i) * pos--;
      if (pos < 2) pos = 9;
    }

    result = sum % 11 < 2 ? 0 : 11 - (sum % 11);
    if (result !== parseInt(digits.charAt(1))) return false;

    return true;
  };

  const formatCPFOrCNPJ = (value) => {
    if (!value) return "";

    const cleaned = value.replace(/\D/g, "");
    return cleaned.length <= 11 ? formatCPF(value) : formatCNPJ(value);
  };

  const validateCPForCNPJ = (doc) => {
    doc = doc.replace(/\D/g, "");

    if (doc.length === 11) return validateCPF(doc);
    if (doc.length === 14) return validateCNPJ(doc);

    return false;
  };

  const formatCEP = (value) => {
    if (!value) return "";

    const onlyNumbers = value.replace(/\D/g, "");

    if (onlyNumbers.length <= 5) {
      return onlyNumbers;
    }
    return `${onlyNumbers.slice(0,2)}.${onlyNumbers.slice(2, 5)}-${onlyNumbers.slice(5, 8)}`;
  };

  const formatCEPForBackend = (cep) => {
    const cleaned = cep.replace(/\D/g, "");

    return cleaned.replace(/(\d{2})(\d{3})(\d{3})/, "$1.$2-$3");
  };

  const validateCEP = (cep) => {
    const cleanedCEP = cep.replace(/\D/g, "");

    if (cleanedCEP.length !== 8) {
      return false;
    }

    if (/^(\d)\1+$/.test(cleanedCEP)) {
      return false;
    }

    return true;
  };

  const validateEmail = (email) => {
    const regex = /^[^\s@]+@[^\s@]+\.[a-zA-Z]+(\.[a-zA-Z]+)*$/;
    return regex.test(email.trim());
  };

  const formatCardNumber = (value) => {
    if (!value) return "";

    const v = value.replace(/\s+/g, "").replace(/[^0-9]/gi, "");
    const matches = v.match(/\d{4,16}/g);
    const match = (matches && matches[0]) || "";
    const parts = [];

    for (let i = 0, len = match.length; i < len; i += 4) {
      parts.push(match.substring(i, i + 4));
    }

    if (parts.length) {
      return parts.join(" ");
    }
    return v;
  };

  const validateCardNumber = (number) => {
    const cleaned = number.replace(/\D/g, "");

    if (cleaned.length < 13 || cleaned.length > 19) {
      return false;
    }

    let sum = 0;
    let shouldDouble = false;

    for (let i = cleaned.length - 1; i >= 0; i--) {
      let digit = parseInt(cleaned.charAt(i));

      if (shouldDouble) {
        digit *= 2;
        if (digit > 9) {
          digit -= 9;
        }
      }

      sum += digit;
      shouldDouble = !shouldDouble;
    }

    return sum % 10 === 0;
  };

  const formatExpiryDate = (value) => {
    let v = value.replace(/\D/g, ""); 

    if (v.length > 2) {
      v = v.substring(0, 2) + "/" + v.substring(2, 6); 
    }

    return v;
  };

  const validateExpiryDate = (value) => {
    if (!value) return false;

    const [month, year] = value.split("/");

    if (!month || !year || month.length !== 2 || year.length !== 4) {
      return false;
    }

    const numericMonth = parseInt(month, 10);
    const numericYear = parseInt(year, 10);

    if (numericMonth < 1 || numericMonth > 12) {
      return false;
    }

    const currentDate = new Date();
    const currentYear = currentDate.getFullYear();
    const currentMonth = currentDate.getMonth() + 1; 

    if (
      numericYear < currentYear ||
      (numericYear === currentYear && numericMonth < currentMonth)
    ) {
      return false;
    }

    return true;
  };

  const formatCVV = (value) => {
    return value.replace(/\D/g, "").slice(0, 4); 
  };

  const validateCVV = (value) => {
    return /^[0-9]{3,4}$/.test(value); 
  };

  const extractMonthAndYear = (rawValue) => {
    const formatted = formatExpiryDate(rawValue);
    const [month, year] = formatted.split("/");
    return {
      month: month || "",
      year: year ? year.slice(-2) : "", 
    };
  };


  const formatAndValidatePhone = (phone) => {
    const cleanedPhone = phone.replace(/\D/g, '');

    if (cleanedPhone.length !== 10 && cleanedPhone.length !== 11) {
      return null;
    }

    const ddd = cleanedPhone.substring(0, 2);
    const number = cleanedPhone.substring(2);

    const formattedPhone = number.length === 8 
      ? `(${ddd}) ${number.substring(0, 4)}-${number.substring(4)}` 
      : `(${ddd}) ${number.substring(0, 5)}-${number.substring(5)}`;

    return formattedPhone;
  };

  const handleCnpj = async (cnpj, card) => {
    if (card === "empresa") {
      try {
        const cnpjSemFormatacao = cnpj;
  
        if (cnpjSemFormatacao.length === 14) {
          const response = await api.get(
            `/helper/busca-cnpj/${cnpjSemFormatacao}`
          );
  
          if (response) {
            const dataEmpresa = response.data;
  
            setRazaoSocialEmpresa(dataEmpresa.nome ? dataEmpresa.nome : "");
            setNomeFantasiaEmpresa(dataEmpresa.fantasia ? dataEmpresa.fantasia : "");

            const telefoneFormatado = dataEmpresa.telefone !== "(null) null" || dataEmpresa.telefone !== "(null)" || dataEmpresa.telefone !== "null" || dataEmpresa.telefone !== "-"
              ? formatAndValidatePhone(dataEmpresa.telefone) 
              : null;

            setTelefoneEmpresa(telefoneFormatado || "");

            setComplementoEmpresa(dataEmpresa.complemento ? dataEmpresa.complemento : "");
  
            const cep = dataEmpresa.cep ? dataEmpresa.cep : "";
            const cepSemFormatacao = cep.replace(/\D/g, "");
            setCepEmpresa(cepSemFormatacao ? cepSemFormatacao : "");
  
            if (cepSemFormatacao) {
              fetchCep(cepSemFormatacao, "empresa");
            }
  
            setNumeroEmpresa(/^\d+$/.test(dataEmpresa.numero) ? dataEmpresa.numero : "");
  
            setErrorsEmpresa((prevErrors) => ({
              ...prevErrors,
              ...(dataEmpresa.nome && { razaoSocialEmpresa: false }),
              ...(dataEmpresa.fantasia && { nomeFantasiaEmpresa: false }),
              ...(dataEmpresa.telefone && { telefoneEmpresa: false }),
              ...(dataEmpresa.cep && { cepEmpresa: false }),
              ...(dataEmpresa.numero && { numeroEmpresa: false }),
            }));
          }
        }
      } catch (error) {}
    } else {
      try {
        const cnpjSemFormatacao = cnpj;
  
        if (cnpjSemFormatacao.length === 14) {
          const response = await api.get(
            `/helper/busca-cnpj/${cnpjSemFormatacao}`
          );
  
          if (response) {
            const dataPagamento = response.data;
  
            const telefoneFormatado = dataPagamento.telefone !== "(null) null" || dataPagamento.telefone !== "(null)" || dataPagamento.telefone !== "null" || dataPagamento.telefone !== "-"
            ? formatAndValidatePhone(dataPagamento.telefone) 
            : null;

            const cpfCnpjEmpresaRaw = cpfCnpjEmpresa.replace(/\D/g, '');
            const cpfCnpjPagamentoRaw = cpfOrCnpjPagamento.replace(/\D/g, '');
          
            if ((cpfCnpjEmpresaRaw.length === 11 && cpfCnpjPagamentoRaw === cpfCnpjEmpresaRaw) || 
              (cpfCnpjPagamentoRaw.length === 14 && cpfCnpjPagamentoRaw === cpfCnpjEmpresaRaw)) {
                setPhonePagamento(telefoneEmpresa);
                setComplementoPagamento(complementoEmpresa);
              } else {
                setPhonePagamento(telefoneFormatado || "");
                setComplementoPagamento(dataPagamento.complemento);
              }
            
  
            const cepSemFormatacao = dataPagamento.cep.replace(/\D/g, "");
            setCepPagamento(cepSemFormatacao);
  
            if (cepSemFormatacao) {
              fetchCep(cepSemFormatacao, "pagamento");
            }
  
            setNumeroPagamento(dataPagamento.numero);
  
            setErrorsPagamento((prevErrors) => ({
              ...prevErrors,
              ...(dataPagamento.telefone && { phonePagamento: false }),
              ...(dataPagamento.complemento && { complementoPagamento: false }),
              ...(dataPagamento.cep && { cepPagamento: false }),
              ...(dataPagamento.numero && { numeroPagamento: false }),
            }));
          }
        }
      } catch (error) {}
    }
  };

  const fetchCep = async (cep, formType = "empresa") => {
    try {
      const cepData = await buscaCep(cep);
      const { logradouro, bairro, localidade, uf, estado } = cepData;

      switch (formType) {
        case "empresa":
          setEnderecoEmpresa(logradouro);
          setBairroEmpresa(bairro);
          setCidadeEmpresa(localidade);

          if (uf && estado) {
            setUfEmpresa({ value: uf, label: estado });
          }

          setErrorsEmpresa((prev) => ({
            ...prev,
            enderecoEmpresa: false,
            bairroEmpresa: false,
            cidadeEmpresa: false,
            ufEmpresa: false,
            cepEmpresa: false,
          }));
          break;

        case "pagamento":
          setEnderecoPagamento(logradouro);
          setBairroPagamento(bairro);
          setCidadePagamento(localidade);

          if (uf && estado) {
            setUFPagamento({ value: uf, label: estado });
          }

          setErrorsPagamento((prev) => ({
            ...prev,
            enderecoPagamento: false,
            bairroPagamento: false,
            cidadePagamento: false,
            ufPagamento: false,
            cepPagamento: false,
          }));
          break;

        default:
          break;
      }
    } catch (err) {
      store.addNotification({
        title: "Erro!",
        message: identifyErrorMenssage(err),  
        type: "danger",
        insert: "top",
        container: "top-right",
        animationIn: ["animated", "fadeIn"],
        animationOut: ["animated", "fadeOut"],
        dismiss: {
          duration: 4000,
          onScreen: true,
        },
      });

       // Setar o erro de CEP conforme o formType
      if (formType === "empresa") {
        setErrorsEmpresa((prev) => ({
          ...prev,
          cepEmpresa: true,
        }));
      } else if (formType === "pagamento") {
        setErrorsPagamento((prev) => ({
          ...prev,
          cepPagamento: true,
        }));
      }
    }
  };

  useEffect(() => {
    validateDataPlan();
  }, [idPlanGridCard, userCount])

  const validateDataPlan = () => {
    if (Number(idPlanCard) === 0) {
      return false;
    }

    checkPlanErrors(false);

    const newErrorsPlan = {
      selectedPlan: !selectedPlan,
      userCount: !userCount || userCount <= 0,
      revenues: revenues ? revenues <= 0 : false,
    };

    setErrorsPlan(newErrorsPlan);

    const hasErrors = Object.values(newErrorsPlan).some(Boolean)

    return !hasErrors;
  };

  const validateParceiro = () => {
    const hasError = !parceiro?.value;
    setErrorParceiro(hasError);

    if (hasError) {
      store.addNotification({
        title: "Erro!",
        message: "Parceiro não identificado - Verifique o link de compra recebido do parceiro.",
        type: "danger",
        insert: "top",
        container: "top-right",
        animationIn: ["animated", "fadeIn"],
        animationOut: ["animated", "fadeOut"],
        dismiss: {
          duration: 4000,
          onScreen: true,
        },
      });
    }

    return !hasError;
  };

  useEffect(() => {
    if (parceiro?.value) {
      setErrorParceiro(false);
      setStartValidationEmpresa(true);
      setActiveAccordionEmpresa(false);
    } else {
      setActiveAccordionEmpresa(true);
    }
  }, [parceiro]);

  useEffect(() => {
    if (startValidationEmpresa === true) {
      const isValid = initialValidateDataEmpresa();

      if(isValid === true){
        setActiveAccordionFaturamento(false)
      }
    }
  },[
    startValidationEmpresa,
    cpfCnpjEmpresa, 
    nomeCompletoEmpresa, 
    telefoneEmpresa, 
    rgEmpresa, 
    razaoSocialEmpresa, 
    nomeFantasiaEmpresa, 
    telefoneEmpresa,
    cepEmpresa,
    enderecoEmpresa,
    numeroEmpresa,
    complementoEmpresa,
    bairroEmpresa,
    cidadeEmpresa,
    ufEmpresa,
    inscricaoEstadualEmpresa,
    categoriaEmpresa
  ]);

  const initialValidateDataEmpresa = () => {
    const tipoCompra = cpfCnpjEmpresa?.replace(/[^\d]+/g, "").length === 11 ? "PF" : "PJ";

    const valueNumeroEmpresa = numeroEmpresa || "";

    const newErrors = {
      cpfCnpjEmpresa: !cpfCnpjEmpresa?.trim(),
      nomeCompletoEmpresa: tipoCompra === "PF" && !nomeCompletoEmpresa.trim(),
      rgEmpresa: tipoCompra === "PF" && !rgEmpresa.trim(),
      razaoSocialEmpresa: tipoCompra === "PJ" && !razaoSocialEmpresa.trim(),
      nomeFantasiaEmpresa: tipoCompra === "PJ" && !nomeFantasiaEmpresa.trim(),
      telefoneEmpresa: !(telefoneEmpresa || "").trim(),
      cepEmpresa: !(cepEmpresa || "").trim(),
      enderecoEmpresa: !enderecoEmpresa.trim(),
      numeroEmpresa: !(valueNumeroEmpresa || "").trim(),
      bairroEmpresa: !bairroEmpresa.trim(),
      cidadeEmpresa: !cidadeEmpresa.trim(),
      // ufEmpresa: !ufEmpresa.value,
      inscricaoEstadualEmpresa: tipoCompra === "PJ" && !inscricaoEstadualEmpresa.trim(),
      categoriaEmpresa: !categoriaEmpresa.value,
    };
    
    const hasErrors = Object.values(newErrors).some(Boolean);
    
    return !hasErrors;
  };

  const validateDataEmpresa = async () => {
    const tipoCompra = cpfCnpjEmpresa.replace(/[^\d]+/g, "").length === 11 ? "PF" : "PJ";

    const valueNumeroEmpresa = numeroEmpresa || "";

    const newErrors = {
      cpfCnpjEmpresa: !cpfCnpjEmpresa.trim(),
      nomeCompletoEmpresa: tipoCompra === "PF" && !nomeCompletoEmpresa.trim(),
      rgEmpresa: tipoCompra === "PF" && (!rgEmpresa.trim() || !validateRG(rgEmpresa)),
      razaoSocialEmpresa: tipoCompra === "PJ" && !razaoSocialEmpresa.trim(),
      nomeFantasiaEmpresa: tipoCompra === "PJ" && !nomeFantasiaEmpresa.trim(),
      telefoneEmpresa: !(telefoneEmpresa || "").trim() || !validatePhone(telefoneEmpresa),
      cepEmpresa: !(cepEmpresa || "").trim() || !validateCEP(cepEmpresa),
      enderecoEmpresa: !enderecoEmpresa.trim(),
      numeroEmpresa: !(valueNumeroEmpresa || "").trim(),
      bairroEmpresa: !bairroEmpresa.trim(),
      cidadeEmpresa: !cidadeEmpresa.trim(),
      ufEmpresa: !ufEmpresa.value,
      inscricaoEstadualEmpresa: tipoCompra === "PJ" && !inscricaoEstadualEmpresa.trim(),
      categoriaEmpresa: !categoriaEmpresa.value,
    };

    if (cpfCnpjEmpresa.trim()) {
      const resultadoDoc = await validadorCpfCnpj(cpfCnpjEmpresa);
      newErrors.cpfCnpjEmpresa = !resultadoDoc.valido;
    }

    setErrorsEmpresa(newErrors);

    const hasErrors = Object.values(newErrors).some(Boolean);
    setAcordionEmpresaError(hasErrors);

    if (hasErrors && !notificationShown.current) {
      store.addNotification({
        title: "Erro!",
        message: "Verifique todos os campos em vermelho antes de prosseguir",
        type: "danger",
        insert: "top",
        container: "top-right",
        animationIn: ["animated", "fadeIn"],
        animationOut: ["animated", "fadeOut"],
        dismiss: {
          duration: 4000,
          onScreen: true,
        },
      });

      notificationShown.current = true; 
    } else {
      notificationShown.current = false;
    }

    return !hasErrors;
  };

  const buildPayloadEmpresa = () => {
    const tipoCompra = cpfCnpjEmpresa.replace(/[^\d]+/g, "").length === 11 ? "PF" : "PJ";

    return {
      tipo_compra: tipoCompra,
      cad_bairro: bairroEmpresa,
      cad_categoria: categoriaEmpresa.value,
      cad_cep: cepEmpresa,
      cad_cidade: cidadeEmpresa,
      cad_cpf_cnpj: formatCPFOrCNPJ(cpfCnpjEmpresa),
      cad_complemento: complementoEmpresa || "",
      cad_endereco: enderecoEmpresa,
      cad_estado: ufEmpresa.value,
      cad_ie: tipoCompra === "PJ" ? inscricaoEstadualEmpresa : rgEmpresa,
      cad_nome_fantasia: tipoCompra === "PJ" ? nomeFantasiaEmpresa : nomeCompletoEmpresa,
      cad_razao_social: tipoCompra === "PJ" ? razaoSocialEmpresa : nomeCompletoEmpresa,
      cad_numero: numeroEmpresa,
      cad_telefone: telefoneEmpresa,
      utm_campaign: urlParams ? urlParams.utm_campaign : "",
      utm_id: urlParams.utm_id !== "" ? urlParams.utm_id : "0",
      utm_medium: urlParams ? urlParams.utm_medium : "",
      utm_source: urlParams ? urlParams.utm_source : "",
      button: urlParams.button !== "" ? urlParams.button : "0",
    };
  };

  const handleDataEmpresa = (isValidEmpresa) => {
    if (isValidEmpresa === true) {
      localStorage.setItem(STORAGE_EMPRESA, JSON.stringify(buildPayloadEmpresa()));
      setStartValidationFaturamento(true);

      return true;
    }

    return false;
  };

  useEffect(() => {
    if (startValidationFaturamento === true) {
      const isValid = initialValidateDataFaturamento();

      if(isValid === true){
        setActiveAccordionPagamento(false)
      }
    }
  },[startValidationFaturamento,
    nameUserFaturamento, 
    emailUserFaturamento, 
    phoneUserFaturamento, 
    cargoUserFaturamento, 
    workSpaceFaturamento,
    numeroPedidoFaturamento,
  ]);

  const initialValidateDataFaturamento = () => {
    const valueUserFaturamento = nameUserFaturamento || "";
    const valueEmailUserFaturamento = emailUserFaturamento || "";
    const valuePhoneUserFaturamento = phoneUserFaturamento || "";
    const valueCargoUserFaturamento = cargoUserFaturamento.value || "";
    const valueWorkSpaceUserFaturamento = workSpaceFaturamento.value || "";

    const newErrors = {
      nameUserFaturamento: !valueUserFaturamento.trim(),
      emailUserFaturamento: !valueEmailUserFaturamento.trim(),
      phoneUserFaturamento: !valuePhoneUserFaturamento.trim(), 
      cargoUserFaturamento: !valueCargoUserFaturamento,
      workSpaceFaturamento: !valueWorkSpaceUserFaturamento,
    };

    const hasErrors = Object.values(newErrors).some(Boolean);

    return !hasErrors;
  };

  const validateDataFaturamento = async () => {
    const valueUserFaturamento = nameUserFaturamento || "";
    const valueEmailUserFaturamento = emailUserFaturamento || "";
    const valuePhoneUserFaturamento = phoneUserFaturamento || "";
    const valueCargoUserFaturamento = cargoUserFaturamento.value || "";
    const valueWorkSpaceUserFaturamento = workSpaceFaturamento.value || "";

    const newErrors = {
      nameUserFaturamento: !valueUserFaturamento.trim(),
      emailUserFaturamento: !valueEmailUserFaturamento.trim() || !validateEmail(valueEmailUserFaturamento),
      phoneUserFaturamento: !valuePhoneUserFaturamento.trim() || !validatePhone(valuePhoneUserFaturamento), 
      cargoUserFaturamento: !valueCargoUserFaturamento,
      workSpaceFaturamento: !valueWorkSpaceUserFaturamento,
    };

    setErrorsFaturamento(newErrors);

    const hasErrors = Object.values(newErrors).some(Boolean);
    setAcordionFaturamentoError(hasErrors);

    if (hasErrors && !notificationShown.current) {
      store.addNotification({
        title: "Erro!",
        message: "Verifique todos os campos em vermelho antes de prosseguir",
        type: "danger",
        insert: "top",
        container: "top-right",
        animationIn: ["animated", "fadeIn"],
        animationOut: ["animated", "fadeOut"],
        dismiss: {
          duration: 4000,
          onScreen: true,
        },
      });

      notificationShown.current = true; 
    }else {
      notificationShown.current = false;
    }

    return !hasErrors;
  };

  const buildPayloadFaturamento = () => ({
    fat_cargo: cargoUserFaturamento.label,
    fat_departamento: workSpaceFaturamento.value,
    fat_email_env_nfe: emailUserFaturamento,
    fat_num_ped_compra: numeroPedidoFaturamento || "",
    fat_resp_cont_pagar: nameUserFaturamento,
    fat_telefone: phoneUserFaturamento,
    utm_campaign: urlParams ? urlParams.utm_campaign : "",
    utm_id: urlParams.utm_id !== "" ? urlParams.utm_id : "0",
    utm_medium: urlParams ? urlParams.utm_medium : "",
    utm_source: urlParams ? urlParams.utm_source : "",
    button: urlParams.button !== "" ? urlParams.button : "0",
  });

  const handleDataFaturamento = () => {
    localStorage.setItem(STORAGE_FATURAMENTO, JSON.stringify(buildPayloadFaturamento()));
    setStartValidationPagamento(true);

    return true;
  };

  const handleDataPagamento = async () => {
    let newErrors = {};

    if (selectedMetod !== "boleto" && selectedMetod !== "pix") {

      newErrors = {
        parcelas: isAnnualPlanSelected ? !selectedParcelas.value : false,
        cpfOrCnpjPagamento: !cpfOrCnpjPagamento.trim(),
        emailPagamento: !emailPagamento.trim() || !validateEmail(emailPagamento),
        phonePagamento: !phonePagamento.trim() || !validatePhone(phonePagamento),
        cepPagamento: !cepPagamento.trim() || !validateCEP(cepPagamento),
        enderecoPagamento: !enderecoPagamento.trim(),
        numeroPagamento: !numeroPagamento.trim(),
        complementoPagamento: false,
        bairroPagamento: !bairroPagamento.trim(),
        cidadePagamento: !cidadePagamento.trim(),
        ufPagamento: !ufPagamento.value,

        nomeTitularCartao: !nomeTitularCartao.trim(),
        numeroCartao: !numeroCartao.trim() || !validateCardNumber(numeroCartao),
        validade: !validade || !validateExpiryDate(formatExpiryDate(validade)),
        cvv: !cvv.trim() || !validateCVV(cvv),
      }

      if (cpfOrCnpjPagamento.trim()) {
        const resultadoDoc = await validadorCpfCnpj(cpfOrCnpjPagamento);
        newErrors.cpfOrCnpjPagamento = !resultadoDoc.valido;
      }
    } else {
      newErrors = {};
    }

    setErrorsPagamento(newErrors);

    const hasErrors = Object.values(newErrors).some((error) => error === true);

    if (selectedMetod === "boleto" || selectedMetod === "pix") {
      setAcordionPagamentoError(false);
    } else {
      setAcordionPagamentoError(hasErrors);
    }

    if (hasErrors) {
      return false; 
    }

    const { month: expiracao_mes, year: expiracao_ano } =
      extractMonthAndYear(validade);

    // Normaliza valores monetários no formato "1000.00" (sem separador de milhar, ponto como decimal)
    const toDotDecimal = (value) => {
      if (value === null || value === undefined) return "";
      const str = typeof value === "number" ? value.toFixed(2) : String(value);
      const cleaned = str.replace(/\./g, "").replace(",", ".");
      const num = Number(cleaned);
      return isNaN(num) ? "" : num.toFixed(2);
    };

    const isBoletoOuPix = selectedMetod === "boleto" || selectedMetod === "pix";

    const pagamento = {
      tipo_pagamento: selectedMetod === "boleto" ? 1 : selectedMetod === "pix" ? 2 : 3,
      ...(isBoletoOuPix
        ? {}
        : {
            parcelas: isAnnualPlanSelected ? selectedParcelas.value : 1,
            valor_parcelas: isAnnualPlanSelected
              ? brlToNumber(selectedParcelas.valor_parcela)
              : totalPlanValueForParcelas,
          }),

      qtd_users: userCount,
      cupom: cupom ? cupom.toUpperCase() : "",
      valor_total_plano: toDotDecimal(fullValueForUsers),
      valor_total_desconto: totalPlanValueForParcelas ? totalPlanValueForParcelas.toFixed(2) : toDotDecimal(fullValueForUsers),
      valor_desconto: resultValueTotalWithDiscount ? toDotDecimal(resultValueTotalWithDiscount) : toDotDecimal(fullValueForUsers),
      grid_plano: idPlanGridCard,

      nome_cartao: isBoletoOuPix ? "" : nomeTitularCartao.toUpperCase(),
      numero_cartao: isBoletoOuPix ? "" : formatCardNumber(numeroCartao),
      expiracao_mes: isBoletoOuPix ? "" : expiracao_mes,
      expiracao_ano: isBoletoOuPix ? "" : expiracao_ano,
      ccv: isBoletoOuPix ? "" : cvv,
      nome_completo_cartao: isBoletoOuPix ? "" : nameUserFaturamento,
      email_cartao: isBoletoOuPix ? "" : emailPagamento,
      cpf_cnpj_cartao: isBoletoOuPix ? "" : formatCPFOrCNPJ(cpfOrCnpjPagamento),
      cep_cartao: isBoletoOuPix ? "" : formatCEPForBackend(cepPagamento),
      endereco_cartao: isBoletoOuPix ? "" : enderecoPagamento,
      complemento_cartao: isBoletoOuPix ? "" : complementoPagamento,
      fone_cartao: isBoletoOuPix ? "" : phonePagamento,
      cel_cartao: isBoletoOuPix ? "" : phonePagamento,
      numero_endereco_cartao: isBoletoOuPix ? "" : numeroPagamento,
      ...(isBoletoOuPix
        ? {}
        : {
            bairro_cartao: bairroPagamento,
            cidade_cartao: cidadePagamento,
            estado_cartao: ufPagamento.value,
          }),

      salvar_cartao: isBoletoOuPix ? 0 : 1,
      termos: 1,

      utm_campaign: urlParams ? urlParams.utm_campaign : "",
      utm_id: urlParams.utm_id !== "" ? urlParams.utm_id : "0",
      utm_medium: urlParams ? urlParams.utm_medium : "",
      utm_source: urlParams ? urlParams.utm_source : "",
      button: urlParams.button !== "" ? urlParams.button : "0",
    };

    const payload = {
      parceiro: parceiro.value,
      fat_cargo_id: cargoUserFaturamento.value ? Number(cargoUserFaturamento.value) : undefined,
      empresa: buildPayloadEmpresa(),
      faturamento: buildPayloadFaturamento(),
      pagamento,
    };

    try {
      const response = await api.post("/compra/parceiros/pagamento", payload);

      if (response.status === 201) {
        localStorage.setItem("dados_compra_parceiro", JSON.stringify({
          email: emailUserFaturamento,
          parceiro: parceiro.label,
        }));

        window.location.href = `/checkout/parceiros/sucesso?${selectedMetod}`;
      }

      return true;
    } catch (error) {
      store.addNotification({
        title: "Erro!",
        message: error?.response?.data?.message || "Erro ao processar pagamento. Tente novamente.",
        type: "danger",
        insert: "top",
        container: "top-right",
        animationIn: ["animated", "fadeIn"],
        animationOut: ["animated", "fadeOut"],
        dismiss: {
          duration: 4000,
          onScreen: true,
        },
      });
      return false;
    }
  };

  const handleSubmit = async () => {
    if (!termosAceitos || !acordoAceito || errorsPlan.selectedPlan) {
      setIsConfirmLoading(false);
      return;
    }

    setIsConfirmLoading(true);
    saveGtmDataCompra();

    if (!validateParceiro()) {
      setIsConfirmLoading(false);
      return;
    }

    const isValidEmpresa = await validateDataEmpresa();
    const isValidFaturamento = isValidEmpresa ? await validateDataFaturamento() : false;

    if (!isValidEmpresa || !isValidFaturamento) {
      setIsConfirmLoading(false);
      return;
    }

    try {
      const validatePagamento = async () => {
        if (selectedMetod === "boleto" || selectedMetod === "pix") {
          setAcordionPagamentoError(false);
          return true;
        }

        const safeValue = (value) => (value === undefined ? '' : value);
      
        const values = {
          parcelas: safeValue(selectedParcelas.value),
          cpfOrCnpjPagamento: safeValue(cpfOrCnpjPagamento),
          emailPagamento: safeValue(emailPagamento),
          phonePagamento: safeValue(phonePagamento),
          cepPagamento: safeValue(cepPagamento),
          enderecoPagamento: safeValue(enderecoPagamento),
          numeroPagamento: safeValue(numeroPagamento),
          bairroPagamento: safeValue(bairroPagamento),
          cidadePagamento: safeValue(cidadePagamento),
          ufPagamento: safeValue(ufPagamento?.value),
          nomeTitularCartao: safeValue(nomeTitularCartao),
          numeroCartao: safeValue(numeroCartao),
          validade: safeValue(validade),
          cvv: safeValue(cvv)
        };
      
        const newErrors = {
          parcelas: isAnnualPlanSelected ? !values.parcelas : false,
          cpfOrCnpjPagamento: !values.cpfOrCnpjPagamento.trim(),
          emailPagamento: !values.emailPagamento.trim() || !validateEmail(values.emailPagamento),
          phonePagamento: !values.phonePagamento.trim() || !validatePhone(values.phonePagamento),
          cepPagamento: !values.cepPagamento.trim() || !validateCEP(values.cepPagamento),
          enderecoPagamento: !values.enderecoPagamento.trim(),
          numeroPagamento: !values.numeroPagamento.trim(),
          complementoPagamento: false,
          bairroPagamento: !values.bairroPagamento.trim(),
          cidadePagamento: !values.cidadePagamento.trim(),
          ufPagamento: !values.ufPagamento,
          nomeTitularCartao: !values.nomeTitularCartao.trim(),
          numeroCartao: !values.numeroCartao.trim() || !validateCardNumber(values.numeroCartao),
          validade: !values.validade || !validateExpiryDate(formatExpiryDate(values.validade)),
          cvv: !values.cvv.trim() || !validateCVV(values.cvv),
        };

        if (values.cpfOrCnpjPagamento.trim()) {
          const resultadoDoc = await validadorCpfCnpj(values.cpfOrCnpjPagamento);
          newErrors.cpfOrCnpjPagamento = !resultadoDoc.valido;
        }

        setErrorsPagamento(newErrors);
      
        const hasErrors = Object.values(newErrors).some(Boolean);
      
        setAcordionPagamentoError(hasErrors);
    
        if (hasErrors && !notificationShown.current) {
          store.addNotification({
            title: "Erro!",
            message: "Verifique todos os campos em vermelho antes de prosseguir",
            type: "danger",
            insert: "top",
            container: "top-right",
            animationIn: ["animated", "fadeIn"],
            animationOut: ["animated", "fadeOut"],
            dismiss: {
              duration: 4000,
              onScreen: true,
            },
          });
      
          notificationShown.current = true; 
        } else {
          notificationShown.current = false;
        }

        return !hasErrors;
      };

      const isPagamentoValid =
        selectedMetod === "cartao_credito" ? await validatePagamento() : true;

      if (!isPagamentoValid) {
        return;
      }

      await handleDataPagamento();

  } catch (error) {
    if (error?.response && error.response.status === 422 && error.config.url === "/compra/receita") {
      setErrorsPlan((prev) => ({
        ...prev,
        revenues: true,
      }));
      
      store.addNotification({
        title: "Erro!",
        message: identifyErrorMenssage(
          error,
          "ERRO-643 Erro ao processar a receita. Verifique os dados e tente novamente - Tente novamente, se o erro persistir acione o suporte."
        ),
        type: "danger",
        insert: "top",
        container: "top-right",
        animationIn: ["animated", "fadeIn"],
        animationOut: ["animated", "fadeOut"],
        dismiss: {
          duration: 4000,
          onScreen: true,
        },
      });
    }

    if (!error?.response) {
      store.addNotification({
        title: "Erro",
        message: identifyErrorMenssage(error, "ERRO-644 Internal Server Error - Tente novamente, se o erro persistir acione o suporte."),
        type: "danger",
        insert: "top",
        container: "top-right",
        animationIn: ["animated", "fadeIn"],
        animationOut: ["animated", "fadeOut"],
        dismiss: {
          duration: 4000,
          onScreen: true,
        },
      });
    }
  } finally {
    setIsConfirmLoading(false);
  }
  };

  useEffect(() => {
    const cleanedValueNotDiscount = valueMonthNotDiscount.replace(/\./g, "").replace(",", ".");
    const valorSemDesconto = Number(cleanedValueNotDiscount);

    const cleanedValueWithDiscount = valueMonthWithDiscount.replace(/\./g, "").replace(",", ".");
    const valorComDesconto = Number(cleanedValueWithDiscount);
    
    const diferencaMensal = (valorSemDesconto - valorComDesconto) * userCount;

    let resultadoFinal;

    if (cupom && messageCupom !== "") {
      const baseCalculationValue = fullValueAnual && fullValueAnual !== "0,00" ? Number(valueAnualCalcWithMonth).toFixed(2) : valorComDesconto;

      const numericBaseValue = Number(baseCalculationValue);

      const annualReferenceValueStr = fullValueAnual && fullValueAnual !== "0,00"
        ? fullValueAnual.replace(/\./g, "").replace(",", ".")
        : valueMonth.replace(/\./g, "").replace(",", ".");

      const numericAnnualReference = Number(annualReferenceValueStr);

      const finalDiscountValue = fullValueAnual && fullValueAnual !== "0,00" ? (numericBaseValue * userCount) - numericAnnualReference : (numericBaseValue * userCount) - (numericAnnualReference * userCount);

      const RemovedSimbols = Math.abs(finalDiscountValue);
      
      resultadoFinal = RemovedSimbols; 
      
    } else {
      resultadoFinal = fullValueAnual ? diferencaMensal * discountMonths : diferencaMensal;
    }

    // Formatação do valor final
    const valorFormatado = new Intl.NumberFormat("pt-BR", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(resultadoFinal);

    setResultValuetotalWithDiscount(valorFormatado);
  }, [valueMonthNotDiscount, valueMonthWithDiscount, discountMonths, userCount, fullValueAnual, cupom, valueRevenuesPrePago, messageCupom, revenues, valueAnualCalcWithMonth]);

  useEffect(() => {
    const valorSemDesconto = Number(
      valueMonthNotDiscount.replace(/\./g, "").replace(",", ".")
    );

    const calculate = valorSemDesconto * userCount;

    const formated = new Intl.NumberFormat("pt-BR", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(calculate);

    setValueMonthDiscount(formated);
  }, [valueMonthNotDiscount, userCount]);

  useEffect(() => {
    if (!fullValueAnual) return; 
  
    const valorAnual = Number(
      fullValueAnual.toString().replace(/\./g, "").replace(",", ".")
    );
  
    const calculate = valorAnual * userCount;
  
    const formated = new Intl.NumberFormat("pt-BR", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(calculate);
  
    setValueAnual(formated);
  }, [userCount]);


  const checkAndCopyEmpresaData = () => {
    const cpfCnpjEmpresaRaw = cpfCnpjEmpresa.replace(/\D/g, '');
    const cpfCnpjPagamentoRaw = cpfOrCnpjPagamento.replace(/\D/g, '');
  
    if ((cpfCnpjEmpresaRaw.length === 11 && cpfCnpjPagamentoRaw === cpfCnpjEmpresaRaw) || 
        (cpfCnpjPagamentoRaw.length === 14 && cpfCnpjPagamentoRaw === cpfCnpjEmpresaRaw)) {
      
      const cepSemFormatacao = cepEmpresa.replace(/\D/g, "");
  
      setEmailPagamento(emailUserFaturamento)
      setPhonePagamento(telefoneEmpresa);
      setCepPagamento(cepEmpresa); 
      setNumeroPagamento(numeroEmpresa);
      setComplementoPagamento(complementoEmpresa);
      
      setErrorsPagamento((prev) => ({
        ...prev,
        emailPagamento: false,
        phonePagamento: false,
        cepPagamento: false,  
        numeroPagamento: false,
        complementoPagamento: false,
      }));
  
      if (cepSemFormatacao.length === 8) {
        fetchCep(cepSemFormatacao, "pagamento");
      }
  
      return true;
    }
    
    return false;
  };

  const handleTermosClick = () => {
    setShowTermos(true);
  }

  const handlePoliticaClick = () => {
    setShowPolitica(true);
  }

  function handleKeyDownAllowCopyPaste(e) {
    if (
      (e.ctrlKey && (e.key === "v" || e.key === "V" || e.key === "c" || e.key === "C")) ||
      (e.metaKey && (e.key === "v" || e.key === "V" || e.key === "c" || e.key === "C"))
    ) {
      return;
    }
    if (!/[0-9]|Backspace|Delete|Tab|ArrowLeft|ArrowRight/.test(e.key)) {
      e.preventDefault();
    }
  }


  const checkPlanErrors = (currentErrors) => {
    const hasNoErrors = !Object.values(currentErrors).some(Boolean);

    setAcordionPlanError(!hasNoErrors);
  };


  const checkAllEmpresaErrors = (currentErrors) => {
    const hasNoErrors = !Object.values(currentErrors).some(Boolean);
    setAcordionEmpresaError(!hasNoErrors);
  };

  const checkAllFaturamentoErrors = (currentErrors) => {
    const hasNoErrors = !Object.values(currentErrors).some(Boolean);
    setAcordionFaturamentoError(!hasNoErrors);
  };

  const checkAllPagamentoErrors = (currentErrors) => {
    const hasNoErrors = !Object.values(currentErrors).some(Boolean);
    setAcordionPagamentoError(!hasNoErrors);
  };

  const formatCurrency = (value) => {
    return value?.toLocaleString('pt-BR', {
      style: 'currency',
      currency: 'BRL',
    });
  };

  const brlToNumber = (value) => {
    if (typeof value === "number") return value;
    if (value === null || value === undefined) return 0;
    const str = String(value).trim();
    if (!str) return 0;
    const sanitized = str.replace(/[^\d.,-]/g, "");
    const normalized = sanitized.replace(/\./g, "").replace(",", ".");
    const num = Number(normalized);
    return isNaN(num) ? 0 : num;
  };

  const extractTotalValueFromFormattedText = (text) => {
    if (!text) return 0;
    const str = String(text);
    const match = str.match(/\d[\d.]*,\d{2}/);
    if (match && match[0]) {
      return brlToNumber(match[0]);
    }
    return brlToNumber(str);
  };

  useEffect(() => {
    setSelectedMetod("cartao_credito")
  },[])

  const handleAccordionToggle = async (accordionKey) => {
    let canProceed = true;

    switch(openedAccordion) {
      case 'empresa':
        const isValidEmpresa = await validateDataEmpresa();

        if (isValidEmpresa) {
          handleDataEmpresa(isValidEmpresa);
        } else {
          canProceed = false;
        }
        break;
      case 'faturamento':
        const isValidFaturamento = await validateDataFaturamento();

        if (isValidFaturamento) {
          handleDataFaturamento();
        } else {
          canProceed = false;
        }
        break;
      default:
        break;
    }
  
    if (canProceed) {
      setOpenedAccordion(accordionKey);
    }
  };

  const allFieldsValid = () => {
    const valueUserFaturamento = nameUserFaturamento || "";
    const valueEmailUserFaturamento = emailUserFaturamento || "";
    const valuePhoneUserFaturamento = phoneUserFaturamento || "";
    const valueCargoUserFaturamento = cargoUserFaturamento.value || "";
    const valueWorkSpaceUserFaturamento = workSpaceFaturamento.value || "";

    const camposInvalidos = {
      nameUserFaturamento: !valueUserFaturamento.trim(),
      emailUserFaturamento: !valueEmailUserFaturamento.trim(),
      phoneUserFaturamento: !valuePhoneUserFaturamento.trim(),
      cargoUserFaturamento: !valueCargoUserFaturamento,
      workSpaceFaturamento: !valueWorkSpaceUserFaturamento
    };

    const existeCampoInvalido = Object.values(camposInvalidos).some(Boolean);

    if (!existeCampoInvalido) {
      setActiveAccordionPagamento(false);
    }
  }

  const getFormattedValue = () => {
    if (fullValueAnual && fullValueAnual !== "0,00") {
      return `${formatCurrency(fullValueAnual)} /ano`;
    }
  
  if (cupom) {
    if (valuePerMonth && valuePerMonth !== "0,00") {

      let suffix = ""

      if (cupom === "BEMVINDO") {
        const monthlySuffix = (fullValueAnual) ? "" : "";
        suffix = monthlySuffix
      } else {
         const monthlySuffix = (fullValueAnual && fullValueAnual !== "0,00") ? "/ano" : "/mês";
         suffix = monthlySuffix
      }
      
      const numericValue = parseFloat(valuePerMonth.replace(',', '.'));
      
      const totalValue = numericValue * userCount;
      
      const formattedValue = totalValue.toFixed(2).replace('.', ',');

      const returnValue = `${formattedValue} ${suffix}`;
      
      return returnValue;
    }
  } else {
    if (resultvalueUserMonth && resultvalueUserMonth !== "0,00") {
      const monthlySuffix = (fullValueAnual && fullValueAnual !== "0,00") ? "/ano" : "/mês";
      return `${formatCurrency(resultvalueUserMonth)} ${monthlySuffix}`;
    }

    if (valuePerMonth && valuePerMonth !== "0,00") {
      const monthlySuffix = (fullValueAnual && fullValueAnual !== "0,00") ? "/ano" : "/mês";
      
      const numericValue = parseFloat(valuePerMonth.replace(',', '.'));
      
      const totalValue = numericValue * userCount;
      
      const formattedValue = totalValue.toFixed(2).replace('.', ',');

      const returnValue = `${formattedValue} ${monthlySuffix}`;
      
      return returnValue;
    }
  }
  
  return "0,00";
  };

  const totalPlanValueForParcelas = useMemo(() => {
    return extractTotalValueFromFormattedText(getFormattedValue());
  }, [
    fullValueAnual,
    cupom,
    valuePerMonth,
    userCount,
    selectedPlan?.label,
    resultvalueUserMonth,
    valueRevenuesPrePago,
    revenues,
  ]);

  const isAnnualPlanSelected =
    fullValueAnual && fullValueAnual !== "0,00" ? true : false;

  useEffect(() => {
    if (!isAnnualPlanSelected) {
      setParcelasOptions([]);
      setSelectedParcelas({
        value: "",
        label: "",
        valor_parcela: "",
        total_juros: "",
      });
      setErrorsPagamento((prev) => {
        const updatedErrors = { ...prev, parcelas: false };
        checkAllPagamentoErrors(updatedErrors);
        return updatedErrors;
      });
      return;
    }

    if (!totalPlanValueForParcelas || totalPlanValueForParcelas <= 0) return;

    const timeoutId = setTimeout(() => {
      (async () => {
        const raw = await postValueParcelas(totalPlanValueForParcelas);

        const data = Array.isArray(raw)
          ? raw
          : Array.isArray(raw?.data)
            ? raw.data
            : Array.isArray(raw?.data?.data)
              ? raw.data.data
              : null;

        if (!Array.isArray(data)) {
          setParcelasOptions([]);
          return;
        }

        const mappedOptions = data
          .filter((item) => item && item.parcelas)
          .map((item) => ({
            value: item.parcelas,
            total_juros: item.total_juros,
            valor_parcela: item.valor_parcela,
            label: `${item.parcelas}x de ${item.valor_parcela} - ${
              Number(item.parcelas) === 1
                ? `Total sem juros ${item.total_juros}`
                : `Total c/ juros ${item.total_juros}`
            }`,
          }));

        setParcelasOptions(mappedOptions);
      })();
    }, 250);

    return () => clearTimeout(timeoutId);
  }, [totalPlanValueForParcelas, isAnnualPlanSelected]);

  const postValueParcelas = async (value) => {
    try {
      const payload = {
        value: new Intl.NumberFormat("pt-BR", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        })
          .format(Number(value))
          .replace(/\./g, ""),
      };

      const response = await api.post("/compra/parcelas", payload);
      return response?.data;
    } catch {
      return null;
    }
  };

  const formattedValue = () => {
    if (fullValueAnual && fullValueAnual !== "0,00") {
      return `${formatCurrency(fullValueAnual)}`;
    }
  
  if (cupom) {
    if (valuePerMonth && valuePerMonth !== "0,00") {
      
      const monthlySuffix = (fullValueAnual && fullValueAnual !== "0,00") ? "" : "/mês";
      
      const numericValue = parseFloat(valuePerMonth.replace(',', '.'));
      
      const totalValue = numericValue * userCount;
      
      const formattedValue = totalValue.toFixed(2).replace('.', ',');

      if (resultValueMonth !== formattedValue) {
        setResultValueMonth(formattedValue);
      }

      return `${formattedValue} ${monthlySuffix}`;
    }
  } else {
    if (resultvalueUserMonth && resultvalueUserMonth !== "0,00") {
      const monthlySuffix = (!cupom || !messageCupom) ? "/mês" : "";

      if (resultValueMonth !== resultvalueUserMonth) {
        setResultValueMonth(resultvalueUserMonth);
      }

      return `${formatCurrency(resultvalueUserMonth)} ${monthlySuffix}`;
    }

    if (valuePerMonth && valuePerMonth !== "0,00") {
      
      const monthlySuffix = (!cupom || !messageCupom) ? "/mês" : "";
      
      const numericValue = parseFloat(valuePerMonth.replace(',', '.'));
      
      const totalValue = numericValue * userCount;
      
      const formattedValue = totalValue.toFixed(2).replace('.', ',');

      if (resultValueMonth !== formattedValue) {
        setResultValueMonth(formattedValue);
      }
      
      return `${formattedValue} ${monthlySuffix}`;
    }
  }
  
  
  return "0,00";
  };

  useEffect(() => {
    formattedValue()
  }, [fullValueAnual, valuePerMonth, resultvalueUserMonth, cupom, messageCupom, userCount])

  const getValueCalcWithMonth = () => {
    if (fullValueAnual && fullValueAnual !== "0,00" && cupom) {

        const numericValue = parseFloat(valueMonth.replace(',', '.'));

        const totalValue = userCount ? (numericValue * 12) * userCount : numericValue * 12;

        return formatCurrency(totalValue);
    } else {
        const numericValue = parseFloat(valueMonth.replace(',', '.'));

        const totalValue = numericValue * userCount;

        return formatCurrency(totalValue);
    }
  }

  // Removido cálculo pré-pago: checkout somente PLANO PROTHEUS

  useEffect(() => {
     if (fullValueAnual && cupom) {
        const numericValue = parseFloat(valueMonth.replace(',', '.'));

        const totalValue = numericValue * 12;

        setValueAnualCalcWithMonth(totalValue);
     }
  }, [valueMonth, cupom, fullValueAnual])

  // Removido ajuste automático para PLANO BASIC: checkout somente Protheus

  //Função que recarrega a página se tiver utm "cupom"
  useEffect(() => {
    // Verificar se já recarregou a página para o utm_cupom
    const hasReloadedForCupom = localStorage.getItem("@CupomReloaded");
    
    // Verificar se existe o parâmetro utm_cupom na URL
    const queryString = window.location.search;
    const params = new URLSearchParams(queryString);
    const utmCupom = params.get('cupom');
    
    // Se tem utm_cupom e ainda não recarregou a página
    if (utmCupom && hasReloadedForCupom !== "true") {
      // Marcar que já recarregou para não recarregar novamente
      localStorage.setItem("@CupomReloaded", "true");
      // Recarregar a página
      window.location.reload();
    }
  }, []);


  useEffect(() => {
    if (localStorage.getItem(STORAGE_EMPRESA)) {
      const getDataEmpresa = JSON.parse(localStorage.getItem(STORAGE_EMPRESA));

      const cpfOrCnpj = getDataEmpresa.cad_cpf_cnpj;
      const nomeFantasia = getDataEmpresa.cad_nome_fantasia;
      const telefone = getDataEmpresa.cad_telefone;
      const rg = getDataEmpresa.cad_ie;
      const cep = getDataEmpresa.cad_cep;
      if (cep) {
        fetchCep(cep, "empresa");
      }
      const numero = getDataEmpresa.cad_numero;
      const complemento = getDataEmpresa.cad_complemento;
      const uf = getDataEmpresa.cad_estado;
      const categoriaId = getDataEmpresa.cad_categoria;

      setCpfOrCnpjEmpresa(cpfOrCnpj)
       if (cpfOrCnpj) {
        setShowOtherFields(true);
      }
      setNomeCompletoEmpresa(nomeFantasia)
      setTelefoneEmpresa(telefone)
      setRgEmpresa(rg)
      setCepEmpresa(cep)
      setNumeroEmpresa(numero)
      setComplementoEmpresa(complemento)
      setUfEmpresa(uf)

      if (categoriaId && Array.isArray(categoriaOptions) && categoriaOptions.length > 0) {
        const categoriaEncontrado = categoriaOptions.find(workspace => workspace.value === categoriaId);
        if (categoriaEncontrado) {
          setCategoriaEmpresa({
            value: categoriaEncontrado.value,
            label: categoriaEncontrado.label
          });
        }
      }
    }
  },[categoriaOptions])

  useEffect(() => {
    if (localStorage.getItem(STORAGE_FATURAMENTO)) {
      const getDataFaturamento = JSON.parse(localStorage.getItem(STORAGE_FATURAMENTO));
      const nome = getDataFaturamento.fat_resp_cont_pagar;
      const email = getDataFaturamento.fat_email_env_nfe;
      const telefone = getDataFaturamento.fat_telefone;
      const cargoFaturamentoLabel = getDataFaturamento.fat_cargo;
      const workspaceIdFaturamento = getDataFaturamento.fat_departamento;
      const numPedido = getDataFaturamento.fat_num_ped_compra;

      setNameUserFaturamento(nome)
      setEmailUserFaturamento(email)
      setPhoneUserFaturamento(telefone)
      // setCargoUserFaturamento(rg)
      setNumeroPedidoFaturamento(numPedido)

      if (cargoFaturamentoLabel && Array.isArray(cargos) && cargos.length > 0) {
        const cargoEncontrado = cargos.find(workspace => workspace.label === cargoFaturamentoLabel);
        if (cargoEncontrado) {
          setCargoUserFaturamento({
            value: cargoEncontrado.value,
            label: cargoEncontrado.label
          });
        }
      }

      if (workspaceIdFaturamento && Array.isArray(workSpaceOptions) && workSpaceOptions.length > 0) {
        const workspaceEncontrado = workSpaceOptions.find(workspace => workspace.value === workspaceIdFaturamento);
        if (workspaceEncontrado) {
          setWorkSpaceFaturamento({
            value: workspaceEncontrado.value,
            label: workspaceEncontrado.label
          });
        }
      }
    }
  },[cargos, workSpaceOptions])


  return (
    <S.Container>
      <S.LogoHeader id="header">
        <img src={LogoAgroReceita} alt="AgroReceita" />
      </S.LogoHeader>

      <S.Wrapper>
      <AcordionCardSimulation
        hasErrorSelect={errorsPlan.selectedPlan}
        hasErrorUsers={errorsPlan.userCount}
        hasErrorRevenues={errorsPlan.revenues}
        onPlanSelected={setSelectedPlan}
        onUsersCountChanged={(value) => {
          setUserCount(value);
        }}
        onCouponChanged={setCupom}
        onRevenuesChanged={setRevenues}
        onValuePerMonthChanged={setValuePerMonth}
        onValueRevenuesPrePagoChanged={setValueRevenuesPrePago}
        onValueRevenuesPrePagoWithNotDiscount={setValueRevenuesPrePagoWithNotDiscount}
        onFullValueForUsersChanged={setFullValueForUsers}
        onMessageCupomChanged={setMessageCupom}
        onFullValueMonthNotDiscountChanged={setValueMonthNotDiscount}
        onFullValueMonthWithDiscountChanged={setValueMonthWithDiscount}
        onFullValueAnual={setFullValueAnual}
        onValueAnual={setValueAnual}
        onValueMonth={setValueMonth}
        onFullValueNotDiscountAnual={setValueTotalWithDiscount}
        onIdPlanGridCard={setIdPlanGridCard}
        onIdPlanCard={setIdPlanCard}
        acordionError={acordionPlanError}
        onDiscountMonths={setDiscountMonths}
        onQtdDocuments={setQtdDocuments}
        onQtdPrescriptions={setQtdPrescriptions}
        isUserCountDisabled={false}
        fixedPlanId={PLANO_API_ID}
        partnerMode={true}
        selectedPartner={parceiro}
        hasErrorPartner={errorParceiro}
      />

        <AcordionCard 
          title="Dados da empresa" 
          isOpen={openAccordionKey === 'empresa'} 
          hasError={acordionEmpresaError} 
          hasBlock={activeAccordionEmpresa}
          onToggle={(key) => {
            setOpenAccordionKey(key);
            handleAccordionToggle(key);
          }}
          accordionKey="empresa"
        >
          <S.ContainerInputs>
            <S.ContainerForm>
            <InputV3
              id="CPF/CNPJ"
              type="text"
              label="CPF/CNPJ"
              floatingLabelWithAsterisk="CPF/CNPJ"
              value={formatCPFOrCNPJ(cpfCnpjEmpresa)}
              onChange={async (e) => {
                const rawValue = e.target.value.replace(/\D/g, "");
                setCpfOrCnpjEmpresa(rawValue);
                setGetCpfOrCnpjEmpresa(rawValue);

                setErrorsEmpresa((prev) => {
                  const updatedErrors = { ...prev, cpfCnpjEmpresa: false };
                  checkAllEmpresaErrors(updatedErrors);
                  return updatedErrors;
                });

                if (rawValue.length === 11 || rawValue.length === 14) {
                  const checkId = ++cpfCnpjEmpresaCheckRef.current;
                  const resultado = await validadorCpfCnpj(rawValue);
                  if (checkId !== cpfCnpjEmpresaCheckRef.current) return; // usuário já digitou algo novo, descarta resposta desatualizada

                  if (resultado.valido) {
                    setShowOtherFields(true);
                  } else {
                    setErrorsEmpresa((prev) => ({
                     ...prev,
                      cpfCnpjEmpresa: true,
                    }));

                    store.addNotification({
                      title: "CPF/CNPJ inválido!",
                      message: resultado.erro || "Por favor, digite um CPF ou CNPJ válido.",
                      type: "danger",
                      insert: "top",
                      container: "top-right",
                      animationIn: ["animated", "fadeIn"],
                      animationOut: ["animated", "fadeOut"],
                      dismiss: {
                        duration: 4000,
                        onScreen: true,
                      },
                    });
                  }
                }
              }}
              onBlur={() => {
                handleCnpj(cpfCnpjEmpresa, "empresa");
              }}
              onKeyDown={handleKeyDownAllowCopyPaste}
              inputMode="numeric"
              maxLength={18}
              hasError={errorsEmpresa.cpfCnpjEmpresa}
              handleClear={() => {
                setCpfOrCnpjEmpresa("");
              }}
            />

            {showOtherFields && (
              <S.ContainerInputs>
                {formatCPFOrCNPJ(cpfCnpjEmpresa)?.length === 14 ? (
                  <S.ContainerForm>
                    <InputV3
                      id="nome_completo"
                      type="text"
                      label="Nome completo"
                      floatingLabelWithAsterisk="Nome completo"
                      value={nomeCompletoEmpresa}
                      onChange={(e) => {
                        setNomeCompletoEmpresa(e.target.value);

                        setErrorsEmpresa((prev) => {
                          const updatedErrors = { ...prev, nomeCompletoEmpresa: false };
                          checkAllEmpresaErrors(updatedErrors);
                          return updatedErrors;
                        });
                      }}
                      hasError={errorsEmpresa.nomeCompletoEmpresa}
                      handleClear={() => {
                        setNomeCompletoEmpresa("");
                      }}
                    />

                    <InputV3
                      id="Telefone/Celular"
                      type="text"
                      label="Telefone/Celular"
                      floatingLabelWithAsterisk="Telefone/Celular"
                      value={telefoneEmpresa}
                      onChange={(e) => {
                        setTelefoneEmpresa(e.target.value);

                        setErrorsEmpresa((prev) => {
                          const updatedErrors = { ...prev, telefoneEmpresa: false };
                          checkAllEmpresaErrors(updatedErrors);
                          return updatedErrors;
                        });
                      }}
                      hasError={errorsEmpresa.telefoneEmpresa}
                      handleClear={() => {
                        setTelefoneEmpresa("");
                      }}
                    />

                    <InputV3
                      id="rg"
                      type="text"
                      label="RG"
                      floatingLabelWithAsterisk="RG"
                      value={rgEmpresa}
                      onChange={(e) => {
                        const input = e.target.value;
                        const formatted = formatRGRealtime(input);

                        setRgEmpresa(formatted);

                        setErrorsEmpresa((prev) => {
                          const updatedErrors = { ...prev, rgEmpresa: false };
                          checkAllEmpresaErrors(updatedErrors);
                          return updatedErrors;
                        });
                      }}
                      hasError={errorsEmpresa.rgEmpresa}
                      maxLength={12}
                      handleClear={() => {
                        setRgEmpresa("");
                      }}
                    />
                  </S.ContainerForm>
                ) : (
                  <S.ContainerForm>
                    <InputV3
                      id="Razão social"
                      type="text"
                      label="Razão social"
                      floatingLabelWithAsterisk="Razão social"
                      value={razaoSocialEmpresa}
                      onChange={(e) => {
                        setRazaoSocialEmpresa(e.target.value);

                        setErrorsEmpresa((prev) => {
                          const updatedErrors = { ...prev, razaoSocialEmpresa: false };
                          checkAllEmpresaErrors(updatedErrors);
                          return updatedErrors;
                        });
                      }}
                      hasError={errorsEmpresa.razaoSocialEmpresa}
                      handleClear={() => {
                        setRazaoSocialEmpresa("");
                      }}
                    />

                    <InputV3
                      id="Nome fantasia"
                      type="text"
                      label="Nome fantasia"
                      floatingLabelWithAsterisk="Nome fantasia"
                      value={nomeFantasiaEmpresa}
                      onChange={(e) => {
                        setNomeFantasiaEmpresa(e.target.value);

                        setErrorsEmpresa((prev) => {
                          const updatedErrors = { ...prev, nomeFantasiaEmpresa: false };
                          checkAllEmpresaErrors(updatedErrors);
                          return updatedErrors;
                        });
                      }}
                      hasError={errorsEmpresa.nomeFantasiaEmpresa}
                      handleClear={() => {
                        setNomeFantasiaEmpresa("");
                      }}
                    />

                    <InputV3
                      id="telefone/celular"
                      type="telefone/celular"
                      label="Telefone/Celular"
                      floatingLabelWithAsterisk="Telefone/Celular"
                      value={telefoneEmpresa}
                      onChange={(e) => {
                        setTelefoneEmpresa(e.target.value);

                        setErrorsEmpresa((prev) => {
                          const updatedErrors = { ...prev, telefoneEmpresa: false };
                          checkAllEmpresaErrors(updatedErrors);
                          return updatedErrors;
                        });
                      }}
                      hasError={errorsEmpresa.telefoneEmpresa}
                      handleClear={() => {
                        setTelefoneEmpresa("");
                      }}
                    />
                  </S.ContainerForm>
                )}

                <InputV3
                  id="cep"
                  type="text"
                  label="CEP"
                  floatingLabelWithAsterisk="CEP"
                  value={formatCEP(cepEmpresa)}
                  onChange={(e) => {
                    const rawValue = e.target.value.replace(/\D/g, "");
                    setCepEmpresa(rawValue);

                    setErrorsEmpresa((prev) => {
                      const updatedErrors = { ...prev, cepEmpresa: false };
                      checkAllEmpresaErrors(updatedErrors);
                      return updatedErrors;
                    });
                  }}
                  hasError={errorsEmpresa.cepEmpresa}
                  onBlur={() => {
                    if (validateCEP(cepEmpresa)) {
                      fetchCep(cepEmpresa, "empresa");
                    } else if (cepEmpresa) {
                      setErrorsEmpresa((prev) => {
                        const updatedErrors = { ...prev, cepEmpresa: true };
                        checkAllEmpresaErrors(updatedErrors);
                        return updatedErrors;
                      });
                    }
                  }}
                  maxLength={10}
                  inputMode="numeric"
                  onKeyDown={handleKeyDownAllowCopyPaste}
                  handleClear={() => {
                    setCepEmpresa("");
                  }}
                />

                <S.ContainerTwoInputs>
                  <InputV3
                    id="endereco"
                    type="text"
                    label="Endereço"
                    floatingLabelWithAsterisk="Endereço"
                    value={enderecoEmpresa}
                    onChange={(e) => {
                      setEnderecoEmpresa(e.target.value);

                      setErrorsEmpresa((prev) => {
                        const updatedErrors = { ...prev, enderecoEmpresa: false };
                        checkAllEmpresaErrors(updatedErrors);
                        return updatedErrors;
                      });
                    }}
                    hasError={errorsEmpresa.enderecoEmpresa}
                    handleClear={() => {
                      setEnderecoEmpresa("");
                    }}
                  />

                  <InputV3
                    id="numero"
                    type="text"
                    label="Número"
                    floatingLabelWithAsterisk="Número"
                    value={numeroEmpresa}
                    onChange={(e) => {
                      setNumeroEmpresa(e.target.value);

                      setErrorsEmpresa((prev) => {
                        const updatedErrors = { ...prev, numeroEmpresa: false };
                        checkAllEmpresaErrors(updatedErrors);
                        return updatedErrors;
                      });
                    }}
                    hasError={errorsEmpresa.numeroEmpresa}
                    handleClear={() => {
                      setNumeroEmpresa("");
                    }}
                  />
                </S.ContainerTwoInputs>

                <InputV3
                  id="complemento"
                  type="text"
                  label="Complemento"
                  floatingLabel="Complemento"
                  value={complementoEmpresa}
                  onChange={(e) => {
                    setComplementoEmpresa(e.target.value);

                    setErrorsEmpresa((prev) => {
                      const updatedErrors = { ...prev, complementoEmpresa: false };
                      checkAllEmpresaErrors(updatedErrors);
                      return updatedErrors;
                    });
                  }}
                  handleClear={() => {
                    setComplementoEmpresa("");
                  }}
                />

                <InputV3
                  id="bairro"
                  type="text"
                  label="Bairro"
                  floatingLabelWithAsterisk="Bairro"
                  value={bairroEmpresa}
                  onChange={(e) => {
                    setBairroEmpresa(e.target.value);

                    setErrorsEmpresa((prev) => {
                      const updatedErrors = { ...prev, bairroEmpresa: false };
                      checkAllEmpresaErrors(updatedErrors);
                      return updatedErrors;
                    });
                  }}
                  hasError={errorsEmpresa.bairroEmpresa}
                  handleClear={() => {
                    setBairroEmpresa("");
                  }}
                />

                <S.ContainerTwoInputs>
                  <InputV3
                    id="cidade"
                    type="text"
                    label="Cidade"
                    floatingLabelWithAsterisk="Cidade"
                    value={cidadeEmpresa}
                    onChange={(e) => {
                      setCidadeEmpresa(e.target.value);

                      setErrorsEmpresa((prev) => {
                        const updatedErrors = { ...prev, cidadeEmpresa: false };
                        checkAllEmpresaErrors(updatedErrors);
                        return updatedErrors;
                      });
                    }}
                    hasError={errorsEmpresa.cidadeEmpresa}
                    handleClear={() => {
                      setCidadeEmpresa("");
                    }}
                  />

                  <InputV3
                    id="EstadoEmpresa"
                    type="select"
                    typeValueSelect="string"
                    floatingLabelWithAsterisk="UF"
                    value={ufEmpresa ? ufEmpresa.value : ""}
                    onChange={(selectedOption) => {
                      setUfEmpresa(selectedOption);

                      setErrorsEmpresa((prev) => {
                        const updatedErrors = { ...prev, ufEmpresa: false };
                        checkAllEmpresaErrors(updatedErrors);
                        return updatedErrors;
                      });
                    }}
                    options={ufOptions}
                    hasError={errorsEmpresa.ufEmpresa}
                    floatingValue={ufEmpresa ? ufEmpresa.value : ""}
                  />
                </S.ContainerTwoInputs>

                {formatCPFOrCNPJ(cpfCnpjEmpresa)?.length === 14 ? ("") : (
                  <InputV3
                    id="inscrição_estadual"
                    type="text"
                    label="Inscrição Estadual"
                    floatingLabelWithAsterisk="Inscrição Estadual"
                    value={inscricaoEstadualEmpresa}
                    onChange={(e) => {
                      setInscricaoEstadualEmpresa(e.target.value);

                      setErrorsEmpresa((prev) => {
                        const updatedErrors = { ...prev, inscricaoEstadualEmpresa: false };
                        checkAllEmpresaErrors(updatedErrors);
                        return updatedErrors;
                      });
                    }}
                    hasError={errorsEmpresa.inscricaoEstadualEmpresa}
                    handleClear={() => {
                      setInscricaoEstadualEmpresa("");
                    }}
                  />
                )}

                <InputV3
                  id="categoria"
                  type="select"
                  typeValueSelect="number"
                  label="Categoria"
                  floatingLabelWithAsterisk="Categoria"
                  value={categoriaEmpresa.label}
                  onChange={(selectedOption) => {
                    setCategoriaEmpresa(selectedOption);

                    setErrorsEmpresa((prev) => {
                      const updatedErrors = { ...prev, categoriaEmpresa: false };
                      checkAllEmpresaErrors(updatedErrors);
                      return updatedErrors;
                    });
                  }}
                  options={categoriaOptions}
                  hasError={errorsEmpresa.categoriaEmpresa}
                  floatingValue={categoriaEmpresa.label}
                />
              </S.ContainerInputs>
            )}
            </S.ContainerForm>
          </S.ContainerInputs>
        </AcordionCard>

        <AcordionCard 
          title="Dados de faturamento" 
          isOpen={openAccordionKey === 'faturamento'} 
          hasError={acordionFaturamentoError} 
          hasBlock={activeAccordionFaturamento}
          onToggle={(key) => {
            setOpenAccordionKey(key);
            handleAccordionToggle(key);

            allFieldsValid()
          }}
          accordionKey="faturamento"
        >
          <S.ContainerInputs>
            <S.ContainerForm>
              <InputV3
                id="Nome do Responsável financeiro"
                type="text"
                label="Nome do Responsável financeiro"
                floatingLabelWithAsterisk="Nome do Responsável financeiro"
                value={nameUserFaturamento}
                onChange={(e) => {
                  setNameUserFaturamento(e.target.value);

                  setErrorsFaturamento((prev) => {
                    const updatedErrors = { ...prev, nameUserFaturamento: false };
                    checkAllFaturamentoErrors(updatedErrors);
                    return updatedErrors;
                  });
                }}
                hasError={errorsFaturamento.nameUserFaturamento}
                handleClear={() => {
                  setNameUserFaturamento("");
                }}
              />

              <InputV3
                id="E-mail"
                type="text"
                label="E-mail"
                floatingLabelWithAsterisk="E-mail"
                value={emailUserFaturamento}
                onChange={(e) => {
                  setEmailUserFaturamento(e.target.value);

                  setErrorsFaturamento((prev) => {
                    const updatedErrors = { ...prev, emailUserFaturamento: false };
                    checkAllFaturamentoErrors(updatedErrors);
                    return updatedErrors;
                  });
                }}
                hasError={errorsFaturamento.emailUserFaturamento}
                handleClear={() => {
                  setEmailUserFaturamento("");
                }}
              />

              <InputV3
                id="Telefone/Celular"
                type="telefone/celular"
                label="Telefone/Celular"
                floatingLabelWithAsterisk="Telefone/Celular"
                value={phoneUserFaturamento}
                onChange={(e) => {
                  setPhoneUserFaturamento(e.target.value);

                  setErrorsFaturamento((prev) => {
                    const updatedErrors = { ...prev, phoneUserFaturamento: false };
                    checkAllFaturamentoErrors(updatedErrors);
                    return updatedErrors;
                  });
                }}
                hasError={errorsFaturamento.phoneUserFaturamento}
                handleClear={() => {
                  setPhoneUserFaturamento("");
                }}
              />

              <InputV3
                id="cargo_faturamento"
                type="select"
                typeValueSelect="number"
                label="Cargo faturamento"
                floatingLabelWithAsterisk="Cargo"
                // value={cargoUserFaturamento.label}
                floatingValue={cargoUserFaturamento.label}
                onChange={(selectedOption) => {
                  setCargoUserFaturamento({
                          value: selectedOption.value,
                          label: selectedOption.label
                      })

                  setErrorsFaturamento((prev) => {
                    const updatedErrors = { ...prev, cargoUserFaturamento: false };
                    checkAllFaturamentoErrors(updatedErrors);
                    return updatedErrors;
                  });
                }}
                options={cargos.map(cargo => ({ 
                      value: cargo.value, 
                      label: cargo.label }))}
                hasError={errorsFaturamento.cargoUserFaturamento}
              />

              <InputV3
                id="Departamento"
                type="select"
                typeValueSelect="number"
                floatingLabelWithAsterisk="Local de trabalho"
                value={workSpaceFaturamento.label}
                onChange={(selectedOption) => {
                  setWorkSpaceFaturamento({
                    value: selectedOption.value,
                    label: selectedOption.label,
                  });

                  setErrorsFaturamento((prev) => {
                    const updatedErrors = { ...prev, workSpaceFaturamento: false };
                    checkAllFaturamentoErrors(updatedErrors);
                    return updatedErrors;
                  });
                }}
                options={workSpaceOptions}
                hasError={errorsFaturamento.workSpaceFaturamento}
                floatingValue={workSpaceFaturamento.label}
              />

              <InputV3
                id="Número do Pedido"
                type="text"
                label="Número do Pedido"
                floatingLabel="Número do Pedido"
                value={numeroPedidoFaturamento}
                onChange={(e) => {
                  setNumeroPedidoFaturamento(e.target.value);

                  setErrorsFaturamento((prev) => {
                    const updatedErrors = { ...prev, numeroPedidoFaturamento: false };
                    checkAllFaturamentoErrors(updatedErrors);
                    return updatedErrors;
                  });
                }}
                handleClear={() => {
                  setNumeroPedidoFaturamento("");
                }}
              />
            </S.ContainerForm>
          </S.ContainerInputs>
        </AcordionCard>

        <AcordionCard
          title="Dados de pagamento"
          isOpen={openAccordionKey === 'pagamento'}
          height={selectedMetod === "boleto" || selectedMetod === "pix" ? true : false}
          hasError={acordionPagamentoError}
          Padding={true}
          hasBlock={activeAccordionPagamento}
          onToggle={(key) => {
            setOpenAccordionKey(key);
            handleAccordionToggle(key);
          }}
          accordionKey="pagamento"
        >
          <S.ContainerContent>
          <S.ContainerInputs>
            <S.DescriptionPrice>
                {cupom ? (
                    <S.ContainerCupomPriceDiscount>
                      <S.CupomPriceDiscount>
                        <BodyP fontWeight={400} color={theme.colors.gray.Cinza_2}>
                          Subtotal
                        </BodyP>

                        <BodyP fontWeight={700} color={theme.colors.gray.Cinza_2}>
                          {fullValueAnual ? 
                          getValueCalcWithMonth() :
                          `R$ ${formatCurrency(valueMonthDiscount)}`}
                        </BodyP>
                      </S.CupomPriceDiscount>

                      <S.CupomPriceDiscount>
                        <BodyP fontWeight={400} color={theme.colors.gray.Cinza_2}>
                          Desconto cupom
                        </BodyP>

                        <BodyP fontWeight={700} color={theme.colors.red.Tostado}>
                          -R$ {resultValueTotalWithDiscount}
                        </BodyP>
                      </S.CupomPriceDiscount>
                    </S.ContainerCupomPriceDiscount>
                ) : ("")}

                <S.TotalPrice>
                  <div
                    style={{
                      width: "192px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "flex-end",
                    }}
                  >
                    <H6 color={theme.colors.gray.Cinza_2}>Total a pagar</H6>
                  </div>

                  <div
                    style={{
                      width: "192px",
                      display: "flex",
                      flexDirection: "column",
                    }}
                  >
                    <H6 color={theme.colors.gray.Cinza_2}>
                      R${" "}
                      {getFormattedValue()}
                    </H6>

                    {cupom && messageCupom ? (
                      <>
                        <Minimo
                          fontWeight={400}
                          color={theme.colors.gray.Cinza_5}
                        >
                          {messageCupom}
                        </Minimo>
                      </>
                    ) : (
                      ""
                    )}
                  </div>
                </S.TotalPrice>
              </S.DescriptionPrice>

              <S.ContainerCardPlans as="form" selectedPlan={selectedPlan} grid={true}>
                <CardRadio
                  selected={selectedMetod === "pix"}
                  onClick={() => {
                    setSelectedMetod("pix")

                    setAcordionPagamentoError(false)

                    setErrorsPagamento({
                      parcelas: false,
                      cpfOrCnpjPagamento: false,
                      emailPagamento: false,
                      phonePagamento: false,
                      cepPagamento: false,
                      enderecoPagamento: false,
                      numeroPagamento: false,
                      complementoPagamento: false,
                      bairroPagamento: false,
                      cidadePagamento: false,
                      ufPagamento: false,

                      nomeTitularCartao: false,
                      numeroCartao: false,
                      validade: false,
                      cvv: false,
                    })
                  }}
                  id="pix"
                  checked={selectedMetod === "pix"}
                  onChange={() => {
                    setSelectedMetod("pix")

                    setAcordionPagamentoError(false)
                  }}
                >
                  <S.CardPlansHeader>
                    <BodyG fontWeight={800} color={theme.colors.gray.Cinza_2}>Pix</BodyG>

                    <Auxiliar color={theme.colors.gray.Cinza_5}>
                      Liberação imediata
                    </Auxiliar>
                  </S.CardPlansHeader>
                </CardRadio>

                <CardRadio
                  selected={selectedMetod === "boleto"}
                  onClick={() => {
                    setSelectedMetod("boleto")

                    setAcordionPagamentoError(false)

                    setErrorsPagamento({
                      parcelas: false,
                      cpfOrCnpjPagamento: false,
                      emailPagamento: false,
                      phonePagamento: false,
                      cepPagamento: false,
                      enderecoPagamento: false,
                      numeroPagamento: false,
                      complementoPagamento: false,
                      bairroPagamento: false,
                      cidadePagamento: false,
                      ufPagamento: false,

                      nomeTitularCartao: false,
                      numeroCartao: false,
                      validade: false,
                      cvv: false,
                    })
                  }}
                  id="boleto"
                  checked={selectedMetod === "boleto"}
                  onChange={() => {
                    setSelectedMetod("boleto")

                    setAcordionPagamentoError(false)
                  }}
                >
                  <S.CardPlansHeader>
                    <BodyG  fontWeight={800} color={theme.colors.gray.Cinza_2}>Boleto</BodyG>

                    <Auxiliar color={theme.colors.gray.Cinza_5}>
                      Até 3 dias para liberação
                    </Auxiliar>
                  </S.CardPlansHeader>
                </CardRadio>

                <CardRadio
                  selected={selectedMetod === "cartao_credito"}
                  onClick={() => setSelectedMetod("cartao_credito")}
                  id="cartao_credito"
                  checked={selectedMetod === "cartao_credito"}
                  onChange={() => setSelectedMetod("cartao_credito")}
                >
                  <S.CardPlansHeader>
                    <BodyG fontWeight={800} color={theme.colors.gray.Cinza_2}>Cartão de crédito</BodyG>

                    <Auxiliar color={theme.colors.gray.Cinza_5}>
                      Liberação imediata
                    </Auxiliar>
                  </S.CardPlansHeader>
                </CardRadio>
              </S.ContainerCardPlans>

              {selectedMetod === "boleto" || selectedMetod === "pix" ? (
                ""
              ) : (
                <S.ContainerForm>
                  {isAnnualPlanSelected ? (
                    <InputV3
                      id="parcelas"
                      type="select"
                      label="Parcelas"
                      floatingLabelWithAsterisk="Parcelas"
                      typeValueSelect="number"
                      value={selectedParcelas?.value ? selectedParcelas : ""}
                      onChange={(selectedOption) => {
                        const matched = parcelasOptions.find(
                          (opt) =>
                            Number(opt?.value) === Number(selectedOption?.value)
                        );
                        setSelectedParcelas(matched || selectedOption);

                        setErrorsPagamento((prev) => {
                          const updatedErrors = { ...prev, parcelas: false };
                          checkAllPagamentoErrors(updatedErrors);
                          return updatedErrors;
                        });
                      }}
                      options={parcelasOptions}
                      hasError={errorsPagamento.parcelas}
                    />
                  ) : null}

                  <InputV3
                    id="CPF/CNPJ do titular"
                    type="text"
                    label="CPF/CNPJ do titular"
                    floatingLabelWithAsterisk="CPF/CNPJ do titular"
                    value={formatCPFOrCNPJ(cpfOrCnpjPagamento)}
                    onChange={async (e) => {
                      const rawValue = e.target.value.replace(/\D/g, "");
                      setCpfOrCnpjPagamento(rawValue);

                      setErrorsPagamento((prev) => {
                        const updatedErrors = { ...prev, cpfOrCnpjPagamento: false };
                        checkAllPagamentoErrors(updatedErrors);
                        return updatedErrors;
                      });

                      if (rawValue.length === 11 || rawValue.length === 14) {
                        const checkId = ++cpfOrCnpjPagamentoCheckRef.current;
                        const resultado = await validadorCpfCnpj(rawValue);
                        if (checkId !== cpfOrCnpjPagamentoCheckRef.current) return; // usuário já digitou algo novo, descarta resposta desatualizada

                        if (!resultado.valido) {
                          setErrorsPagamento((prev) => ({
                            ...prev,
                            cpfOrCnpjPagamento: true,
                          }));

                          store.addNotification({
                            title: "CPF/CNPJ inválido!",
                            message: resultado.erro || "Por favor, digite um CPF ou CNPJ válido.",
                            type: "danger",
                            insert: "top",
                            container: "top-right",
                            animationIn: ["animated", "fadeIn"],
                            animationOut: ["animated", "fadeOut"],
                            dismiss: {
                              duration: 4000,
                              onScreen: true,
                            },
                          });
                        }
                      }
                    }}
                    onBlur={() => {
                      // handleCnpj(cpfOrCnpjPagamento, "pagamento");
                      checkAndCopyEmpresaData()
                    }}
                    onKeyDown={handleKeyDownAllowCopyPaste}
                    inputMode="numeric"
                    maxLength={18}
                    hasError={errorsPagamento.cpfOrCnpjPagamento}
                    handleClear={() => {
                      setCpfOrCnpjPagamento("");
                    }}
                  />

                  <InputV3
                    id="E-mail"
                    type="text"
                    label="E-mail"
                    floatingLabelWithAsterisk="E-mail"
                    value={emailPagamento}
                    onChange={(e) => {
                      setEmailPagamento(e.target.value);

                      setErrorsPagamento((prev) => {
                        const updatedErrors = { ...prev, emailPagamento: false };
                        checkAllPagamentoErrors(updatedErrors);
                        return updatedErrors;
                      });
                    }}
                    hasError={errorsPagamento.emailPagamento}
                    handleClear={() => {
                      setEmailPagamento("");
                    }}
                  />

                  <InputV3
                    id="Telefone/Celular"
                    type="telefone/celular"
                    label="Telefone/Celular"
                    floatingLabelWithAsterisk="Telefone/Celular"
                    value={phonePagamento}
                    onChange={(e) => {
                      setPhonePagamento(e.target.value);

                      setErrorsPagamento((prev) => {
                        const updatedErrors = { ...prev, phonePagamento: false };
                        checkAllPagamentoErrors(updatedErrors);
                        return updatedErrors;
                      });
                    }}
                    hasError={errorsPagamento.phonePagamento}
                    handleClear={() => {
                      setPhonePagamento("");
                    }}
                  />

                  <InputV3
                    id="CEP"
                    type="text"
                    label="CEP"
                    floatingLabelWithAsterisk="CEP"
                    value={formatCEP(cepPagamento)}
                    onChange={(e) => {
                      const rawValue = e.target.value.replace(/\D/g, ""); 
                      setCepPagamento(rawValue);

                      setErrorsPagamento((prev) => {
                        const updatedErrors = { ...prev, cepPagamento: false };
                        checkAllPagamentoErrors(updatedErrors);
                        return updatedErrors;
                      });

                      if (rawValue.length === 8) {
                        fetchCep(rawValue, "pagamento");
                      }
                    }}
                    hasError={errorsPagamento.cepPagamento}
                    onBlur={() => {
                      if (validateCEP(cepPagamento)) {
                        fetchCep(cepPagamento, "pagamento");
                      } else if (cepPagamento) {
                        setErrorsPagamento((prev) => ({
                          ...prev,
                          cepPagamento: true,
                        }));
                      }
                    }}
                    maxLength={10}
                    inputMode="numeric"
                    onKeyDown={handleKeyDownAllowCopyPaste}
                    handleClear={() => {
                      setCepPagamento("");
                    }}
                  />

                  <S.ContainerTwoInputs>
                    <InputV3
                      id="Endereço"
                      type="text"
                      label="Endereço"
                      floatingLabelWithAsterisk="Endereço"
                      value={enderecoPagamento}
                      onChange={(e) => {
                        setEnderecoPagamento(e.target.value);

                        setErrorsPagamento((prev) => {
                          const updatedErrors = { ...prev, enderecoPagamento: false };
                          checkAllPagamentoErrors(updatedErrors);
                          return updatedErrors;
                        });
                      }}
                      hasError={errorsPagamento.enderecoPagamento}
                      handleClear={() => {
                        setEnderecoPagamento("");
                      }}
                    />

                    <InputV3
                      id="Número"
                      type="text"
                      label="Número"
                      floatingLabelWithAsterisk="Número"
                      value={numeroPagamento}
                      onChange={(e) => {
                        setNumeroPagamento(e.target.value);

                        setErrorsPagamento((prev) => {
                          const updatedErrors = { ...prev, numeroPagamento: false };
                          checkAllPagamentoErrors(updatedErrors);
                          return updatedErrors;
                        });
                      }}
                      hasError={errorsPagamento.numeroPagamento}
                      handleClear={() => {
                        setNumeroPagamento("");
                      }}
                    />
                  </S.ContainerTwoInputs>

                  <InputV3
                    id="Complemento"
                    type="text"
                    label="Complemento"
                    floatingLabel="Complemento"
                    value={complementoPagamento}
                    onChange={(e) => {
                      setComplementoPagamento(e.target.value);

                      setErrorsPagamento((prev) => {
                        const updatedErrors = { ...prev, complementoPagamento: false };
                        checkAllPagamentoErrors(updatedErrors);
                        return updatedErrors;
                      });
                    }}
                    hasError={errorsPagamento.complementoPagamento}
                    handleClear={() => {
                      setComplementoPagamento("");
                    }}
                  />

                  <InputV3
                    id="Bairro"
                    type="text"
                    label="Bairro"
                    floatingLabelWithAsterisk="Bairro"
                    value={bairroPagamento}
                    onChange={(e) => {
                      setBairroPagamento(e.target.value);

                      setErrorsPagamento((prev) => {
                        const updatedErrors = { ...prev, bairroPagamento: false };
                        checkAllPagamentoErrors(updatedErrors);
                        return updatedErrors;
                      });
                    }}
                    hasError={errorsPagamento.bairroPagamento}
                    handleClear={() => {
                      setBairroPagamento("");
                    }}
                  />

                  <S.ContainerTwoInputs>
                    <InputV3
                      id="Cidade"
                      type="text"
                      label="Cidade"
                      floatingLabelWithAsterisk="Cidade"
                      value={cidadePagamento}
                      onChange={(e) => {
                        setCidadePagamento(e.target.value);

                        setErrorsPagamento((prev) => {
                          const updatedErrors = { ...prev, cidadePagamento: false };
                          checkAllPagamentoErrors(updatedErrors);
                          return updatedErrors;
                        });
                      }}
                      hasError={errorsPagamento.cidadePagamento}
                      handleClear={() => {
                        setCidadePagamento("");
                      }}
                    />

                    <InputV3
                      id="UF"
                      type="select"
                      typeValueSelect="string"
                      floatingLabelWithAsterisk="UF"
                      value={ufPagamento.value}
                      onChange={(selectedOption) => {
                        setUFPagamento(selectedOption);

                        setErrorsPagamento((prev) => {
                          const updatedErrors = { ...prev, ufPagamento: false };
                          checkAllPagamentoErrors(updatedErrors);
                          return updatedErrors;
                        });
                      }}
                      options={ufOptions}
                      hasError={errorsPagamento.ufPagamento}
                      floatingValue={ufPagamento.value}
                    />
                  </S.ContainerTwoInputs>

                  <InputV3
                    id="Nome do titular (conforme impresso no cartão)"
                    type="text"
                    label="Nome do titular (conforme impresso no cartão)"
                    floatingLabelWithAsterisk="Nome do titular (conforme impresso no cartão)"
                    value={nomeTitularCartao}
                    onChange={(e) => {
                      setNomeTitularCartao(e.target.value);

                      setErrorsPagamento((prev) => {
                        const updatedErrors = { ...prev, nomeTitularCartao: false };
                        checkAllPagamentoErrors(updatedErrors);
                        return updatedErrors;
                      });
                    }}
                    hasError={errorsPagamento.nomeTitularCartao}
                    handleClear={() => {
                      setNomeTitularCartao("");
                    }}
                  />

                  <InputV3
                    id="Número do cartão"
                    type="text"
                    label="Número do cartão"
                    floatingLabelWithAsterisk="Número do cartão"
                    value={formatCardNumber(numeroCartao)} 
                    onChange={(e) => {
                      const rawValue = e.target.value.replace(/\D/g, "");
                      setNumeroCartao(rawValue);

                      setErrorsPagamento((prev) => {
                        const updatedErrors = { ...prev, numeroCartao: false };
                        checkAllPagamentoErrors(updatedErrors);
                        return updatedErrors;
                      });
                    }}
                    onBlur={() => {
                      if (numeroCartao && !validateCardNumber(numeroCartao)) {
                        setErrorsPagamento((prev) => ({
                          ...prev,
                          numeroCartao: true,
                        }));
                      }
                    }}
                    hasError={errorsPagamento.numeroCartao}
                    inputMode="numeric" 
                    maxLength={19}
                    onKeyDown={handleKeyDownAllowCopyPaste}
                    handleClear={() => {
                      setNumeroCartao("");
                    }}
                  />

                  <S.ContainerTwoInputs>
                    <InputV3
                      id="Validade (mm/aaaa)"
                      type="text"
                      label="Validade (mm/aaaa)"
                      floatingLabelWithAsterisk="Validade (mm/aaaa)"
                      value={formatExpiryDate(validade)} 
                      onChange={(e) => {
                        const rawValue = e.target.value.replace(/\D/g, "");
                        setValidade(rawValue);

                        setErrorsPagamento((prev) => {
                          const updatedErrors = { ...prev, validade: false };
                          checkAllPagamentoErrors(updatedErrors);
                          return updatedErrors;
                        });
                      }}
                      onBlur={() => {
                        if (
                          validade &&
                          !validateExpiryDate(formatExpiryDate(validade))
                        ) {
                          setErrorsPagamento((prev) => ({
                            ...prev,
                            validade: true,
                          }));
                        }
                      }}
                      hasError={errorsPagamento.validade}
                      inputMode="numeric" 
                      maxLength={7}
                      placeholder="MM/AAAA"
                      onKeyDown={handleKeyDownAllowCopyPaste}
                      handleClear={() => {
                        setValidade("");
                      }}
                    />

                    <InputV3
                      id="CVV"
                      type="text" 
                      label="CVV"
                      floatingLabelWithAsterisk="CVV"
                      value={formatCVV(cvv)} 
                      onChange={(e) => {
                        const rawValue = formatCVV(e.target.value);
                        setCvv(rawValue);

                        setErrorsPagamento((prev) => {
                          const updatedErrors = { ...prev, cvv: false };
                          checkAllPagamentoErrors(updatedErrors);
                          return updatedErrors;
                        });
                      }}
                      onBlur={() => {
                        if ( cvv && !validateCVV(cvv)) {
                          setErrorsPagamento((prev) => ({
                            ...prev,
                            cvv: true,
                          }));
                        }
                      }}
                      hasError={errorsPagamento.cvv}
                      inputMode="numeric" 
                      maxLength={4} 
                      onKeyDown={handleKeyDownAllowCopyPaste}
                      handleClear={() => {
                        setCvv("");
                      }}
                    />
                  </S.ContainerTwoInputs>
                </S.ContainerForm>
              )}
            </S.ContainerInputs>

            {fullValueAnual === null && cupom === "BEMVINDO" ? (
              <Minimo
                style={{ textAlign: "center" }}
                color={theme.colors.gray.Cinza_2}
              >
                A partir da segunda mensalidade:{" "}
                <b>R$ {valueMonthDiscount}/mês</b>
              </Minimo>
            ): ("")}
          </S.ContainerContent>
        </AcordionCard>

        <S.ContainerCheckbox>
          <S.ContainerInputCheckbox>
            <input
              type="checkbox"
              id="termosPolitica"
              name="termosPolitica"
              checked={termosAceitos}
              onChange={(e) => setTermosAceitos(e.target.checked)}
            />

            <BodyP>
              Li e concordo com os <span onClick={() => handleTermosClick()}>Termos de uso</span> e a{" "}
              <span onClick={() => handlePoliticaClick()}>Politica de Privacidade</span>
            </BodyP>
          </S.ContainerInputCheckbox>

          <S.ContainerInputCheckbox>
            <input
              type="checkbox"
              id="declaroAcordo"
              name="declaroAcordo"
              checked={acordoAceito}
              onChange={(e) => setAcordoAceito(e.target.checked)}
            />
            <BodyP>Declaro que estou ciente e de acordo</BodyP>
          </S.ContainerInputCheckbox>
        </S.ContainerCheckbox>

        <S.ButtonSubmit
          isDisabled={!termosAceitos || !acordoAceito || errorsPlan.selectedPlan}
          onClick={() => {
            if (!termosAceitos || !acordoAceito || errorsPlan.selectedPlan) return;
            handleSubmit();
          }}
        >
          {isConfirmLoading ? (
            <S.Loading />
          ) : (
            <TaglineM fontWeight={800}>Concluir compra</TaglineM>
          )}
        </S.ButtonSubmit>
      </S.Wrapper>

      <ModalTermos
          show={showTermos}
          btnOk={true}
          onHide={() => setShowTermos(false)}
      />

      <ModalPoliticas
          show={showPolitica}
          btnOk={true}
          onHide={() => setShowPolitica(false)}
      />
    </S.Container>
  );
};

export default CompraParceiros;
